[
  {
    "codigo": "BR004",
    "nome": "Alvar�es",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Alvar�es",
    "municipioIbge": 1300020,
    "latitude": -3.211,
    "longitude": -64.807
  },
  {
    "codigo": "BR005",
    "nome": "Amatur�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Amatur�",
    "municipioIbge": 1300060,
    "latitude": -3.36,
    "longitude": -68.196
  },
  {
    "codigo": "BR006",
    "nome": "Anaj�s",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Anaj�s",
    "municipioIbge": 1500700,
    "latitude": -0.986999,
    "longitude": -49.93999899999999
  },
  {
    "codigo": "BR007",
    "nome": "Anam�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Anam�",
    "municipioIbge": 1300080,
    "latitude": -3.582,
    "longitude": -61.405
  },
  {
    "codigo": "BR009",
    "nome": "Anori",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Anori",
    "municipioIbge": 1300100,
    "latitude": -3.749,
    "longitude": -61.66
  },
  {
    "codigo": "BR010",
    "nome": "Apu�",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "AM",
    "municipioNome": "Novo Aripuan�",
    "municipioIbge": 1303300,
    "latitude": -7.5,
    "longitude": -60.661
  },
  {
    "codigo": "BR011",
    "nome": "Assis Brasil",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AC",
    "municipioNome": "Assis Brasil",
    "municipioIbge": 1200050,
    "latitude": -10.942609,
    "longitude": -69.56693
  },
  {
    "codigo": "BR012",
    "nome": "Atalaia do Norte",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Atalaia do Norte",
    "municipioIbge": 1300200,
    "latitude": -4.368,
    "longitude": -70.193
  },
  {
    "codigo": "BR013",
    "nome": "Augusto Corr�a",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "PA",
    "municipioNome": "Augusto Corr�a",
    "municipioIbge": 1500900,
    "latitude": -1.024,
    "longitude": -46.636
  },
  {
    "codigo": "BR014",
    "nome": "Autazes",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Autazes",
    "municipioIbge": 1300300,
    "latitude": -3.579,
    "longitude": -59.131
  },
  {
    "codigo": "BR015",
    "nome": "Aveiro",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "PA",
    "municipioNome": "Aveiro",
    "municipioIbge": 1501000,
    "latitude": -3.605,
    "longitude": -55.324
  },
  {
    "codigo": "BR016",
    "nome": "Barcarena",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Barcarena",
    "municipioIbge": 1501300,
    "latitude": -1.492289,
    "longitude": -48.591099
  },
  {
    "codigo": "BR017",
    "nome": "Barcelos",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "AM",
    "municipioNome": "Barcelos",
    "municipioIbge": 1300400,
    "latitude": -0.969,
    "longitude": -62.925
  },
  {
    "codigo": "BR018",
    "nome": "Barreirinha",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Barreirinha",
    "municipioIbge": 1300500,
    "latitude": -2.793,
    "longitude": -57.071
  },
  {
    "codigo": "BR020",
    "nome": "Belo Monte",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Senador Jos� Porf�rio",
    "municipioIbge": 1507800,
    "latitude": -2.590999,
    "longitude": -51.954
  },
  {
    "codigo": "BR022",
    "nome": "Beruri",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Beruri",
    "municipioIbge": 1300630,
    "latitude": -3.897,
    "longitude": -61.376
  },
  {
    "codigo": "BR024",
    "nome": "Boa Vista do Ramos",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Boa Vista do Ramos",
    "municipioIbge": 1300680,
    "latitude": -2.97,
    "longitude": -57.59
  },
  {
    "codigo": "BR027",
    "nome": "Brasil�ia",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AC",
    "municipioNome": "Brasil�ia",
    "municipioIbge": 1200100,
    "latitude": -11.009999,
    "longitude": -68.748
  },
  {
    "codigo": "BR029",
    "nome": "Bujaru",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Bujaru",
    "municipioIbge": 1501900,
    "latitude": -1.514999,
    "longitude": -48.045
  },
  {
    "codigo": "BR030",
    "nome": "Caapiranga",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Caapiranga",
    "municipioIbge": 1300830,
    "latitude": -3.333,
    "longitude": -61.211
  },
  {
    "codigo": "BR031",
    "nome": "Cabixi",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RO",
    "municipioNome": "Cabixi",
    "municipioIbge": 1100030,
    "latitude": -13.653947,
    "longitude": -60.79448
  },
  {
    "codigo": "BR032",
    "nome": "Cacau Pereira",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Iranduba",
    "municipioIbge": 1301850,
    "latitude": -3.154,
    "longitude": -60.092
  },
  {
    "codigo": "BR033",
    "nome": "Cachoeira Rasteira",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Jacareacanga",
    "municipioIbge": 1503750,
    "latitude": -8.736866,
    "longitude": -57.5955
  },
  {
    "codigo": "BR034",
    "nome": "Porto Velho � Cai N� �gua",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "RO",
    "municipioNome": "Porto Velho",
    "municipioIbge": 1100200,
    "latitude": -8.762,
    "longitude": -63.904
  },
  {
    "codigo": "BR036",
    "nome": "Canutama",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Canutama",
    "municipioIbge": 1300900,
    "latitude": -6.536,
    "longitude": -64.383
  },
  {
    "codigo": "BR037",
    "nome": "Caracara�",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "RR",
    "municipioNome": "Caracara�",
    "municipioIbge": 1400200,
    "latitude": 1.823,
    "longitude": -61.125
  },
  {
    "codigo": "BR038",
    "nome": "Carauari",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Carauari",
    "municipioIbge": 1301000,
    "latitude": -4.881,
    "longitude": -66.895
  },
  {
    "codigo": "BR039",
    "nome": "Careiro da V�rzea",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Careiro da V�rzea",
    "municipioIbge": 1301150,
    "latitude": -3.19,
    "longitude": -59.869
  },
  {
    "codigo": "BR042",
    "nome": "Colares",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Colares",
    "municipioIbge": 1502600,
    "latitude": -0.93,
    "longitude": -48.289
  },
  {
    "codigo": "BR045",
    "nome": "Cucu�",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "S�o Gabriel da Cachoeira",
    "municipioIbge": 1303800,
    "latitude": 1.184737,
    "longitude": -66.837666
  },
  {
    "codigo": "BR046",
    "nome": "Cutias",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AP",
    "municipioNome": "Cutias",
    "municipioIbge": 1600210,
    "latitude": 0.9720070000000001,
    "longitude": -50.80146600000001
  },
  {
    "codigo": "BR047",
    "nome": "Destacamento Guapor�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Comodoro",
    "municipioIbge": 5103300,
    "latitude": -14.004113,
    "longitude": -60.34675
  },
  {
    "codigo": "BR049",
    "nome": "Envira",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Envira",
    "municipioIbge": 1301500,
    "latitude": -7.433,
    "longitude": -70.025
  },
  {
    "codigo": "BR050",
    "nome": "Epit�ciol�ndia",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AC",
    "municipioNome": "Epitaciol�ndia",
    "municipioIbge": 1200250,
    "latitude": -10.917203,
    "longitude": -68.656066
  },
  {
    "codigo": "BR052",
    "nome": "Ferreira Gomes",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AP",
    "municipioNome": "Ferreira Gomes",
    "municipioIbge": 1600230,
    "latitude": 0.857999,
    "longitude": -51.17999900000001
  },
  {
    "codigo": "BR053",
    "nome": "Floresta do Araguaia",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Floresta do Araguaia",
    "municipioIbge": 1503040,
    "latitude": -7.493,
    "longitude": -49.385
  },
  {
    "codigo": "BR054",
    "nome": "Fonte Boa",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Fonte Boa",
    "municipioIbge": 1301600,
    "latitude": -2.511,
    "longitude": -66.092
  },
  {
    "codigo": "BR055",
    "nome": "Guajar�",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Guajar�",
    "municipioIbge": 1301650,
    "latitude": -7.548,
    "longitude": -72.579
  },
  {
    "codigo": "BR057",
    "nome": "Gurup�",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Gurup�",
    "municipioIbge": 1503100,
    "latitude": -1.405,
    "longitude": -51.64000000000001
  },
  {
    "codigo": "BR059",
    "nome": "Iauaret�",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "S�o Gabriel da Cachoeira",
    "municipioIbge": 1303800,
    "latitude": 0.606003,
    "longitude": -69.190187
  },
  {
    "codigo": "BR060",
    "nome": "Ipixuna",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Ipixuna",
    "municipioIbge": 1301800,
    "latitude": -7.053,
    "longitude": -71.694
  },
  {
    "codigo": "BR063",
    "nome": "Itacoatiara (novo)",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "AM",
    "municipioNome": "Itacoatiara",
    "municipioIbge": 1301900,
    "latitude": -3.216,
    "longitude": -59.025
  },
  {
    "codigo": "BR065",
    "nome": "Itamarati",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "AM",
    "municipioNome": "Itamarati",
    "municipioIbge": 1301950,
    "latitude": -6.44,
    "longitude": -68.245
  },
  {
    "codigo": "BR068",
    "nome": "Itaubal",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AP",
    "municipioNome": "Itaubal",
    "municipioIbge": 1600250,
    "latitude": 0.421294,
    "longitude": -50.589216
  },
  {
    "codigo": "BR069",
    "nome": "Itupiranga",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Itupiranga",
    "municipioIbge": 1503700,
    "latitude": -5.134,
    "longitude": -49.325
  },
  {
    "codigo": "BR071",
    "nome": "Japur�",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "AM",
    "municipioNome": "Japur�",
    "municipioIbge": 1302100,
    "latitude": -1.877,
    "longitude": -66.996
  },
  {
    "codigo": "BR073",
    "nome": "Jord�o",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AC",
    "municipioNome": "Jord�o",
    "municipioIbge": 1200320,
    "latitude": -9.192762,
    "longitude": -71.949773
  },
  {
    "codigo": "BR074",
    "nome": "Juru�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Juru�",
    "municipioIbge": 1302200,
    "latitude": -3.472,
    "longitude": -66.062
  },
  {
    "codigo": "BR075",
    "nome": "Juruti",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "PA",
    "municipioNome": "Juruti",
    "municipioIbge": 1503900,
    "latitude": -2.152,
    "longitude": -56.095
  },
  {
    "codigo": "BR076",
    "nome": "Juta�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Juta�",
    "municipioIbge": 1302300,
    "latitude": -2.743,
    "longitude": -66.767
  },
  {
    "codigo": "BR079",
    "nome": "Limoeiro do Ajuru",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Limoeiro do Ajuru",
    "municipioIbge": 1504000,
    "latitude": -1.893,
    "longitude": -49.38
  },
  {
    "codigo": "BR081",
    "nome": "Machadinho  D'Oeste",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RO",
    "municipioNome": "Machadinho D'Oeste",
    "municipioIbge": 1100130,
    "latitude": -9.163663,
    "longitude": -61.640936
  },
  {
    "codigo": "BR083",
    "nome": "Manaquiri",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Manaquiri",
    "municipioIbge": 1302550,
    "latitude": -3.428,
    "longitude": -60.459
  },
  {
    "codigo": "BR085",
    "nome": "Manaus Moderna",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Manaus",
    "municipioIbge": 1302600,
    "latitude": -3.139872,
    "longitude": -60.02286999999999
  },
  {
    "codigo": "BR086",
    "nome": "M�ncio Lima",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AC",
    "municipioNome": "M�ncio Lima",
    "municipioIbge": 1200330,
    "latitude": -7.602456000000001,
    "longitude": -72.899895
  },
  {
    "codigo": "BR088",
    "nome": "Manoel Urbano",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AC",
    "municipioNome": "Manoel Urbano",
    "municipioIbge": 1200340,
    "latitude": -8.838998,
    "longitude": -69.26
  },
  {
    "codigo": "BR089",
    "nome": "Mara�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Mara�",
    "municipioIbge": 1302800,
    "latitude": -1.861,
    "longitude": -65.591
  },
  {
    "codigo": "BR090",
    "nome": "Marechal Thaumaturgo",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "AC",
    "municipioNome": "Marechal Thaumaturgo",
    "municipioIbge": 1200350,
    "latitude": -8.947211,
    "longitude": -72.785878
  },
  {
    "codigo": "BR092",
    "nome": "Mazag�o",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AP",
    "municipioNome": "Mazag�o",
    "municipioIbge": 1600400,
    "latitude": -0.128838,
    "longitude": -51.279992
  },
  {
    "codigo": "BR093",
    "nome": "Miritituba",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Itaituba",
    "municipioIbge": 1503600,
    "latitude": -4.275998,
    "longitude": -55.98400000000001
  },
  {
    "codigo": "BR094",
    "nome": "Moju",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Moju",
    "municipioIbge": 1504700,
    "latitude": -1.883,
    "longitude": -48.766
  },
  {
    "codigo": "BR096",
    "nome": "Moura",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Barcelos",
    "municipioIbge": 1300400,
    "latitude": -0.9750000000000001,
    "longitude": -62.923999
  },
  {
    "codigo": "BR097",
    "nome": "Muan�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Muan�",
    "municipioIbge": 1504900,
    "latitude": -1.529,
    "longitude": -49.216
  },
  {
    "codigo": "BR098",
    "nome": "Nhamund�",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Nhamund�",
    "municipioIbge": 1303000,
    "latitude": -2.193,
    "longitude": -56.713
  },
  {
    "codigo": "BR099",
    "nome": "Nova Mamor�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RO",
    "municipioNome": "Nova Mamor�",
    "municipioIbge": 1100330,
    "latitude": -10.3944,
    "longitude": -65.376867
  },
  {
    "codigo": "BR100",
    "nome": "Nova Olinda do Norte",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Nova Olinda do Norte",
    "municipioIbge": 1303100,
    "latitude": -3.888,
    "longitude": -59.094
  },
  {
    "codigo": "BR101",
    "nome": "Novo Air�o",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Novo Air�o",
    "municipioIbge": 1303200,
    "latitude": -2.622,
    "longitude": -60.944
  },
  {
    "codigo": "BR104",
    "nome": "Oeiras do Par�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Oeiras do Par�",
    "municipioIbge": 1505200,
    "latitude": -1.918,
    "longitude": -49.841
  },
  {
    "codigo": "BR106",
    "nome": "Oliveira Machado",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Manaus",
    "municipioIbge": 1302600,
    "latitude": -3.142551999999999,
    "longitude": -60.01643899999999
  },
  {
    "codigo": "BR109",
    "nome": "Parintins (Vila Amazonas)",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Parintins",
    "municipioIbge": 1303400,
    "latitude": -2.626,
    "longitude": -56.737
  },
  {
    "codigo": "BR110",
    "nome": "Pauin�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Pauini",
    "municipioIbge": 1303500,
    "latitude": -7.717,
    "longitude": -66.999
  },
  {
    "codigo": "BR111",
    "nome": "Pedra Branca do Amapari",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AP",
    "municipioNome": "Pedra Branca do Amapar�",
    "municipioIbge": 1600150,
    "latitude": 0.7608649999999999,
    "longitude": -51.945877
  },
  {
    "codigo": "BR113",
    "nome": "Pl�cido de Castro",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AC",
    "municipioNome": "Pl�cido de Castro",
    "municipioIbge": 1200380,
    "latitude": -10.292313,
    "longitude": -67.134115
  },
  {
    "codigo": "BR114",
    "nome": "Portel",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Portel",
    "municipioIbge": 1505800,
    "latitude": -1.937,
    "longitude": -50.825
  },
  {
    "codigo": "BR115",
    "nome": "Porto Acre",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AC",
    "municipioNome": "Porto Acre",
    "municipioIbge": 1200800,
    "latitude": -9.589311,
    "longitude": -67.5313
  },
  {
    "codigo": "BR116",
    "nome": "Porto Cotrigua�u",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Cotrigua�u",
    "municipioIbge": 5103370,
    "latitude": -9.879124,
    "longitude": -58.235419
  },
  {
    "codigo": "BR118",
    "nome": "Porto do P�lo Industrial de Manaus",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Manaus",
    "municipioIbge": 1302600,
    "latitude": -3.120876,
    "longitude": -59.925672
  },
  {
    "codigo": "BR120",
    "nome": "Porto Grande",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AP",
    "municipioNome": "Porto Grande",
    "municipioIbge": 1600530,
    "latitude": 0.712999,
    "longitude": -51.41299900000001
  },
  {
    "codigo": "BR121",
    "nome": "Porto Velho � Rio Candeias",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RO",
    "municipioNome": "Porto Velho",
    "municipioIbge": 1100200,
    "latitude": -8.800377,
    "longitude": -63.720794
  },
  {
    "codigo": "BR122",
    "nome": "Porto Velho (novo)",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "RO",
    "municipioNome": "Porto Velho",
    "municipioIbge": 1100200,
    "latitude": -8.588092,
    "longitude": -63.729372
  },
  {
    "codigo": "BR123",
    "nome": "Porto Vit�ria",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Vit�ria do Xingu",
    "municipioIbge": 1508350,
    "latitude": -2.88389,
    "longitude": -52.009199
  },
  {
    "codigo": "BR124",
    "nome": "Porto Walter",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "AC",
    "municipioNome": "Porto Walter",
    "municipioIbge": 1200390,
    "latitude": -8.268999,
    "longitude": -72.743999
  },
  {
    "codigo": "BR125",
    "nome": "Pracu�ba",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AP",
    "municipioNome": "Pracu�ba",
    "municipioIbge": 1600550,
    "latitude": 1.743,
    "longitude": -50.79099899999999
  },
  {
    "codigo": "BR126",
    "nome": "Prainha",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Prainha",
    "municipioIbge": 1506000,
    "latitude": -1.808002,
    "longitude": -53.478512
  },
  {
    "codigo": "BR127",
    "nome": "Quatipuru - Boa Vista",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Quatipuru",
    "municipioIbge": 1506110,
    "latitude": -0.901,
    "longitude": -47.07
  },
  {
    "codigo": "BR128",
    "nome": "Quatipuru - Sede",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Quatipuru",
    "municipioIbge": 1506110,
    "latitude": -0.897,
    "longitude": -47.005
  },
  {
    "codigo": "BR130",
    "nome": "Rio Preto da Eva",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Rio Preto da Eva",
    "municipioIbge": 1303560,
    "latitude": -2.699,
    "longitude": -59.703
  },
  {
    "codigo": "BR131",
    "nome": "Rodrigues Alves",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AC",
    "municipioNome": "Rodrigues Alves",
    "municipioIbge": 1200420,
    "latitude": -7.732514999999999,
    "longitude": -72.647017
  },
  {
    "codigo": "BR132",
    "nome": "Salin�polis",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Salin�polis",
    "municipioIbge": 1506200,
    "latitude": -0.612736,
    "longitude": -47.34637899999999
  },
  {
    "codigo": "BR134",
    "nome": "Santa Isabel do Rio Negro",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Santa Isabel do Rio Negro",
    "municipioIbge": 1303600,
    "latitude": -0.417,
    "longitude": -65.021
  },
  {
    "codigo": "BR135",
    "nome": "Santa Maria das Barreiras",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Santa Maria das Barreiras",
    "municipioIbge": 1506580,
    "latitude": -8.872,
    "longitude": -49.716
  },
  {
    "codigo": "BR136",
    "nome": "Santa Rosa do Purus",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "AC",
    "municipioNome": "Santa Rosa do Purus",
    "municipioIbge": 1200430,
    "latitude": -9.430551,
    "longitude": -70.492102
  },
  {
    "codigo": "BR138",
    "nome": "Santar�m (novo)",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Santar�m Novo",
    "municipioIbge": 1506900,
    "latitude": -0.929409,
    "longitude": -47.40029999999999
  },
  {
    "codigo": "BR139",
    "nome": "Santar�m � Terminal de Cargas",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Santar�m",
    "municipioIbge": 1506800,
    "latitude": -2.419,
    "longitude": -54.722
  },
  {
    "codigo": "BR140",
    "nome": "Santo Ant�nio do I��",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Santo Ant�nio do I��",
    "municipioIbge": 1303700,
    "latitude": -3.108,
    "longitude": -67.946
  },
  {
    "codigo": "BR141",
    "nome": "Santo Ant�nio do Tau�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Santo Ant�nio do Tau�",
    "municipioIbge": 1507000,
    "latitude": -1.107,
    "longitude": -48.224
  },
  {
    "codigo": "BR144",
    "nome": "S�o Jo�o do Araguaia",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "S�o Jo�o do Araguaia",
    "municipioIbge": 1507500,
    "latitude": -5.356,
    "longitude": -48.789
  },
  {
    "codigo": "BR145",
    "nome": "S�o Miguel do Guam�",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "PA",
    "municipioNome": "Irituia",
    "municipioIbge": 1503500,
    "latitude": -1.627,
    "longitude": -47.485
  },
  {
    "codigo": "BR147",
    "nome": "S�o Raimundo",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Manaus",
    "municipioIbge": 1302600,
    "latitude": -3.125,
    "longitude": -60.043
  },
  {
    "codigo": "BR148",
    "nome": "S�o Sebasti�o da Boa Vista",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "S�o Sebasti�o da Boa Vista",
    "municipioIbge": 1507700,
    "latitude": -1.717,
    "longitude": -49.532
  },
  {
    "codigo": "BR149",
    "nome": "S�o Sebasti�o do Uatum�",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "S�o Sebasti�o do Uatum�",
    "municipioIbge": 1303950,
    "latitude": -2.573,
    "longitude": -57.87
  },
  {
    "codigo": "BR151",
    "nome": "Senador Jos� Porf�rio",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Senador Jos� Porf�rio",
    "municipioIbge": 1507800,
    "latitude": -2.876501,
    "longitude": -51.891201
  },
  {
    "codigo": "BR152",
    "nome": "Serra do Navio",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AP",
    "municipioNome": "Serra do Navio",
    "municipioIbge": 1600050,
    "latitude": 0.9039739999999999,
    "longitude": -52.036799
  },
  {
    "codigo": "BR155",
    "nome": "Tapau�",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Tapau�",
    "municipioIbge": 1304100,
    "latitude": -5.625,
    "longitude": -63.19
  },
  {
    "codigo": "BR156",
    "nome": "Tapuruquara",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Santa Isabel do Rio Negro",
    "municipioIbge": 1303600,
    "latitude": -0.4167890000000001,
    "longitude": -65.021198
  },
  {
    "codigo": "BR158",
    "nome": "Tartarugalzinho",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AP",
    "municipioNome": "Tartarugalzinho",
    "municipioIbge": 1600700,
    "latitude": 1.516557,
    "longitude": -50.858306
  },
  {
    "codigo": "BR159",
    "nome": "Tef�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Tef�",
    "municipioIbge": 1304200,
    "latitude": -3.517,
    "longitude": -64.435
  },
  {
    "codigo": "BR161",
    "nome": "Terminal da Condor",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Bel�m",
    "municipioIbge": 1501400,
    "latitude": -1.453885,
    "longitude": -48.402184
  },
  {
    "codigo": "BR162",
    "nome": "Terminal Pesqueiro",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Manaus",
    "municipioIbge": 1302600,
    "latitude": -3.081581,
    "longitude": -59.860674
  },
  {
    "codigo": "BR163",
    "nome": "Terra Santa",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Terra Santa",
    "municipioIbge": 1507970,
    "latitude": -2.111,
    "longitude": -56.491
  },
  {
    "codigo": "BR164",
    "nome": "Tonantins",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Tonantins",
    "municipioIbge": 1304230,
    "latitude": -2.874,
    "longitude": -67.8
  },
  {
    "codigo": "BR165",
    "nome": "Uarini",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Uarini",
    "municipioIbge": 1304260,
    "latitude": -2.984,
    "longitude": -65.107
  },
  {
    "codigo": "BR166",
    "nome": "Urucar�",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Urucar�",
    "municipioIbge": 1304300,
    "latitude": -2.538,
    "longitude": -57.755
  },
  {
    "codigo": "BR167",
    "nome": "Urucurituba",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Urucurituba",
    "municipioIbge": 1304400,
    "latitude": -3.128,
    "longitude": -58.159
  },
  {
    "codigo": "BR168",
    "nome": "Vila Bittencourt",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Japur�",
    "municipioIbge": 1302100,
    "latitude": -1.396388,
    "longitude": -69.426388
  },
  {
    "codigo": "BR170",
    "nome": "Vila Ipiranga",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Santo Ant�nio do I��",
    "municipioIbge": 1303700,
    "latitude": -2.883731,
    "longitude": -69.687171
  },
  {
    "codigo": "BR171",
    "nome": "Viseu",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "PA",
    "municipioNome": "Viseu",
    "municipioIbge": 1508300,
    "latitude": -1.207,
    "longitude": -46.137
  },
  {
    "codigo": "BR173",
    "nome": "Vit�ria do Xingu",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Vit�ria do Xingu",
    "municipioIbge": 1508350,
    "latitude": -2.885269,
    "longitude": -51.960432
  },
  {
    "codigo": "BR174",
    "nome": "Xapuri",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AC",
    "municipioNome": "Xapuri",
    "municipioIbge": 1200700,
    "latitude": -10.650599,
    "longitude": -68.50525
  },
  {
    "codigo": "BR177",
    "nome": "Campinho",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "BA",
    "municipioNome": "Mara�",
    "municipioIbge": 2920700,
    "latitude": -13.928599,
    "longitude": -38.949199
  },
  {
    "codigo": "BR179",
    "nome": "Porto-Sul",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "BA",
    "municipioNome": "Ilh�us",
    "municipioIbge": 2913600,
    "latitude": -14.631325,
    "longitude": -39.065144
  },
  {
    "codigo": "BR182",
    "nome": "�gua Doce do Maranh�o",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "�gua Doce do Maranh�o",
    "municipioIbge": 2100150,
    "latitude": -2.833,
    "longitude": -42.117
  },
  {
    "codigo": "BR183",
    "nome": "Alto Alegre do Pindar�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Alto Alegre do Pindar�",
    "municipioIbge": 2100470,
    "latitude": -3.689999,
    "longitude": -45.90299899999999
  },
  {
    "codigo": "BR184",
    "nome": "Arari",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Arari",
    "municipioIbge": 2101000,
    "latitude": -3.302168,
    "longitude": -44.807114
  },
  {
    "codigo": "BR186",
    "nome": "Bequim�o",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Bequim�o",
    "municipioIbge": 2101900,
    "latitude": -2.334,
    "longitude": -44.837
  },
  {
    "codigo": "BR190",
    "nome": "Espadarte",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Curu��",
    "municipioIbge": 1502900,
    "latitude": -0.703913,
    "longitude": -47.879643
  },
  {
    "codigo": "BR194",
    "nome": "Palmeir�ndia  (Coroat�)",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Palmeir�ndia",
    "municipioIbge": 2107600,
    "latitude": -2.727,
    "longitude": -45.118
  },
  {
    "codigo": "BR195",
    "nome": "Palmeir�ndia (S�o Jos� dos Leite)",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Palmeir�ndia",
    "municipioIbge": 2107600,
    "latitude": -2.582,
    "longitude": -45.057
  },
  {
    "codigo": "BR196",
    "nome": "Palmeir�ndia (Sede)",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Palmeir�ndia",
    "municipioIbge": 2107600,
    "latitude": -2.659,
    "longitude": -45.094
  },
  {
    "codigo": "BR197",
    "nome": "Penalva",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Penalva",
    "municipioIbge": 2108300,
    "latitude": -3.298,
    "longitude": -45.175
  },
  {
    "codigo": "BR198",
    "nome": "Pindar�-Mirim",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Pindar�-Mirim",
    "municipioIbge": 2108500,
    "latitude": -3.604369,
    "longitude": -45.341799
  },
  {
    "codigo": "BR201",
    "nome": "Porto Rico do Maranh�o",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Cururupu",
    "municipioIbge": 2103700,
    "latitude": -1.893,
    "longitude": -44.605
  },
  {
    "codigo": "BR203",
    "nome": "S�o Bento",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "S�o Bento",
    "municipioIbge": 2110500,
    "latitude": -2.6947,
    "longitude": -44.821199
  },
  {
    "codigo": "BR204",
    "nome": "Turia�u",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Turia�u",
    "municipioIbge": 2112400,
    "latitude": -1.672,
    "longitude": -45.369
  },
  {
    "codigo": "BR220",
    "nome": "Reg�ncia",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "ES",
    "municipioNome": "Linhares",
    "municipioIbge": 3203200,
    "latitude": -19.6475,
    "longitude": -39.826599
  },
  {
    "codigo": "BR225",
    "nome": "V�toria - �guas Profundas",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "ES",
    "municipioNome": "Vit�ria",
    "municipioIbge": 3205300,
    "latitude": -20.276641,
    "longitude": -40.236276
  },
  {
    "codigo": "BR227",
    "nome": "Arambar�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "Arambar�",
    "municipioIbge": 4300850,
    "latitude": -30.914999,
    "longitude": -51.497999
  },
  {
    "codigo": "BR237",
    "nome": "Mariante",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "Ven�ncio Aires",
    "municipioIbge": 4322600,
    "latitude": -29.903461,
    "longitude": -51.753554
  },
  {
    "codigo": "BR242",
    "nome": "Rio Pardo",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "Rio Pardo",
    "municipioIbge": 4315700,
    "latitude": -29.995499,
    "longitude": -52.376199
  },
  {
    "codigo": "BR244",
    "nome": "Santana da Boa Vista",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "Santana da Boa Vista",
    "municipioIbge": 4317000,
    "latitude": -30.972908,
    "longitude": -53.04791399999999
  },
  {
    "codigo": "BR247",
    "nome": "S�o Jos� do Norte",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "S�o Jos� do Norte",
    "municipioIbge": 4318500,
    "latitude": -32.014,
    "longitude": -52.042
  },
  {
    "codigo": "BR250",
    "nome": "Tavares",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "Tavares",
    "municipioIbge": 4321350,
    "latitude": -31.223206,
    "longitude": -51.150529
  },
  {
    "codigo": "BR254",
    "nome": "Bar�o de Melga�o",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Bar�o de Melga�o",
    "municipioIbge": 5101600,
    "latitude": -16.289296,
    "longitude": -55.9717
  },
  {
    "codigo": "BR258",
    "nome": "Destacamento Foz do APA",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MS",
    "municipioNome": "Porto Murtinho",
    "municipioIbge": 5006900,
    "latitude": -22.121267,
    "longitude": -57.892288
  },
  {
    "codigo": "BR259",
    "nome": "Destacamento Ingazeira",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MS",
    "municipioNome": "Porto Murtinho",
    "municipioIbge": 5006900,
    "latitude": -22.118967,
    "longitude": -57.836892
  },
  {
    "codigo": "BR260",
    "nome": "Lad�rio",
    "tipo": "Porto P�blico",
    "situacao": "Inoperante",
    "uf": "MS",
    "municipioNome": "Lad�rio",
    "municipioIbge": 5005200,
    "latitude": -19.001245,
    "longitude": -57.599152
  },
  {
    "codigo": "BR261",
    "nome": "Manga",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MS",
    "municipioNome": "Corumb�",
    "municipioIbge": 5003200,
    "latitude": -19.259,
    "longitude": -57.235599
  },
  {
    "codigo": "BR262",
    "nome": "Porto Cercado",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Pocon�",
    "municipioIbge": 5106500,
    "latitude": -16.491209,
    "longitude": -56.368888
  },
  {
    "codigo": "BR263",
    "nome": "Porto Esperan�a",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MS",
    "municipioNome": "Corumb�",
    "municipioIbge": 5003200,
    "latitude": -19.000682,
    "longitude": -57.671313
  },
  {
    "codigo": "BR266",
    "nome": "Santo Ant�nio das Lendas",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "C�ceres",
    "municipioIbge": 5102500,
    "latitude": -16.067881,
    "longitude": -57.692767
  },
  {
    "codigo": "BR267",
    "nome": "Santo Ant�nio de Leverger",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Santo Ant�nio do Leverger",
    "municipioIbge": 5107800,
    "latitude": -15.869678,
    "longitude": -56.076534
  },
  {
    "codigo": "BR268",
    "nome": "Vila Bela da Sant�ssima Trindade",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Vila Bela da Sant�ssima Trindade",
    "municipioIbge": 5105500,
    "latitude": -15.008019,
    "longitude": -59.953403
  },
  {
    "codigo": "BR269",
    "nome": "�gua Vermelha",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MG",
    "municipioNome": "Iturama",
    "municipioIbge": 3134400,
    "latitude": -19.857365,
    "longitude": -50.345465
  },
  {
    "codigo": "BR270",
    "nome": "Anhembi",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "SP",
    "municipioNome": "Anhembi",
    "municipioIbge": 3502300,
    "latitude": -22.771834,
    "longitude": -48.13033600000001
  },
  {
    "codigo": "BR272",
    "nome": "Artemis",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "SP",
    "municipioNome": "Piracicaba",
    "municipioIbge": 3538700,
    "latitude": -22.719334,
    "longitude": -47.65368
  },
  {
    "codigo": "BR273",
    "nome": "Chavesl�ndia (Sta.Vit�ria)",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MG",
    "municipioNome": "Santa Vit�ria",
    "municipioIbge": 3159800,
    "latitude": -19.042709,
    "longitude": -50.49817
  },
  {
    "codigo": "BR274",
    "nome": "Corumbatai",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "SP",
    "municipioNome": "Piracicaba",
    "municipioIbge": 3538700,
    "latitude": -22.688863,
    "longitude": -47.676742
  },
  {
    "codigo": "BR284",
    "nome": "Porto Barragem de Jupi�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MS",
    "municipioNome": "Tr�s Lagoas",
    "municipioIbge": 5008300,
    "latitude": -20.78374,
    "longitude": -51.637023
  },
  {
    "codigo": "BR285",
    "nome": "Porto Mendes",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PR",
    "municipioNome": "Marechal C�ndido Rondon",
    "municipioIbge": 4114600,
    "latitude": -24.4918,
    "longitude": -54.315699
  },
  {
    "codigo": "BR289",
    "nome": "Rubin�ia",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "SP",
    "municipioNome": "Rubin�ia",
    "municipioIbge": 3544500,
    "latitude": -20.175492,
    "longitude": -51.019999
  },
  {
    "codigo": "BR292",
    "nome": "Amarante",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PI",
    "municipioNome": "Amarante",
    "municipioIbge": 2200500,
    "latitude": -6.240999000000001,
    "longitude": -42.854999
  },
  {
    "codigo": "BR293",
    "nome": "Araioses (Barreiras)",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Araioses",
    "municipioIbge": 2100900,
    "latitude": -2.878,
    "longitude": -41.909
  },
  {
    "codigo": "BR294",
    "nome": "Araioses (Carnaubeiras)",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Araioses",
    "municipioIbge": 2100900,
    "latitude": -2.832,
    "longitude": -41.961
  },
  {
    "codigo": "BR297",
    "nome": "Long�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PI",
    "municipioNome": "Palmeirais",
    "municipioIbge": 2207500,
    "latitude": -5.977203,
    "longitude": -43.061873
  },
  {
    "codigo": "BR299",
    "nome": "Miguel Alves",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PI",
    "municipioNome": "Miguel Alves",
    "municipioIbge": 2206200,
    "latitude": -4.15977,
    "longitude": -42.893307
  },
  {
    "codigo": "BR301",
    "nome": "Santa Filomena",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Alto Parna�ba",
    "municipioIbge": 2100500,
    "latitude": -9.114069,
    "longitude": -45.9247
  },
  {
    "codigo": "BR304",
    "nome": "Uru�u�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PI",
    "municipioNome": "Uru�u�",
    "municipioIbge": 2211200,
    "latitude": -7.227108,
    "longitude": -44.556336
  },
  {
    "codigo": "BR309",
    "nome": "Carinhanha",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "BA",
    "municipioNome": "Carinhanha",
    "municipioIbge": 2907100,
    "latitude": -14.304999,
    "longitude": -43.765
  },
  {
    "codigo": "BR310",
    "nome": "Cotegipe",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "BA",
    "municipioNome": "Cotegipe",
    "municipioIbge": 2909400,
    "latitude": -11.811899,
    "longitude": -44.3365
  },
  {
    "codigo": "BR311",
    "nome": "Formosa do Rio Preto",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "BA",
    "municipioNome": "Formosa do Rio Preto",
    "municipioIbge": 2911100,
    "latitude": -11.049799,
    "longitude": -45.1912
  },
  {
    "codigo": "BR314",
    "nome": "Itacarambi",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MG",
    "municipioNome": "Itacarambi",
    "municipioIbge": 3132100,
    "latitude": -15.102,
    "longitude": -44.091999
  },
  {
    "codigo": "BR315",
    "nome": "Janu�ria",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MG",
    "municipioNome": "Janu�ria",
    "municipioIbge": 3135200,
    "latitude": -15.489368,
    "longitude": -44.354578
  },
  {
    "codigo": "BR322",
    "nome": "Riach�o das Neves",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "BA",
    "municipioNome": "Riach�o das Neves",
    "municipioIbge": 2926200,
    "latitude": -11.8275,
    "longitude": -44.7274
  },
  {
    "codigo": "BR324",
    "nome": "Santa Rita de C�ssia",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "BA",
    "municipioNome": "Santa Rita de C�ssia",
    "municipioIbge": 2928400,
    "latitude": -11.0188,
    "longitude": -44.512399
  },
  {
    "codigo": "BR327",
    "nome": "Aguiarn�polis",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "TO",
    "municipioNome": "Aguiarn�polis",
    "municipioIbge": 1700300,
    "latitude": -6.562998,
    "longitude": -47.466
  },
  {
    "codigo": "BR329",
    "nome": "Araguacema",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "TO",
    "municipioNome": "Araguacema",
    "municipioIbge": 1701900,
    "latitude": -8.804,
    "longitude": -49.555999
  },
  {
    "codigo": "BR330",
    "nome": "Araguaiana",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Araguaiana",
    "municipioIbge": 5101000,
    "latitude": -15.733999,
    "longitude": -51.83100000000001
  },
  {
    "codigo": "BR331",
    "nome": "Araguatins",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "TO",
    "municipioNome": "Araguatins",
    "municipioIbge": 1702200,
    "latitude": -5.650999000000001,
    "longitude": -48.124
  },
  {
    "codigo": "BR334",
    "nome": "Bom Jesus do Tocantins",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "TO",
    "municipioNome": "Bom Jesus do Tocantins",
    "municipioIbge": 1703300,
    "latitude": -8.930328,
    "longitude": -48.167621
  },
  {
    "codigo": "BR336",
    "nome": "Cachoeira Dourada",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MG",
    "municipioNome": "Cachoeira Dourada",
    "municipioIbge": 3109800,
    "latitude": -18.515,
    "longitude": -49.500999
  },
  {
    "codigo": "BR337",
    "nome": "Caseara",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "TO",
    "municipioNome": "Caseara",
    "municipioIbge": 1703900,
    "latitude": -9.235676,
    "longitude": -49.96504
  },
  {
    "codigo": "BR338",
    "nome": "Cocalinho",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Cocalinho",
    "municipioIbge": 5103100,
    "latitude": -14.397,
    "longitude": -50.996
  },
  {
    "codigo": "BR340",
    "nome": "Couto Magalh�es",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Concei��o do Araguaia",
    "municipioIbge": 1502700,
    "latitude": -8.27326,
    "longitude": -49.25330000000001
  },
  {
    "codigo": "BR341",
    "nome": "Luci�ra",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Luciara",
    "municipioIbge": 5105300,
    "latitude": -11.221999,
    "longitude": -50.66899899999999
  },
  {
    "codigo": "BR343",
    "nome": "Marab� (multimodal)",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Marab�",
    "municipioIbge": 1504200,
    "latitude": -5.324662,
    "longitude": -49.080146
  },
  {
    "codigo": "BR344",
    "nome": "Marab� (orla)",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Marab�",
    "municipioIbge": 1504200,
    "latitude": -5.331,
    "longitude": -49.115
  },
  {
    "codigo": "BR348",
    "nome": "Pau d�Arco",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "TO",
    "municipioNome": "Pau D''Arco",
    "municipioIbge": 1716300,
    "latitude": -7.543746999999999,
    "longitude": -49.370016
  },
  {
    "codigo": "BR351",
    "nome": "S�o Domingos do Capim",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "S�o Domingos do Capim",
    "municipioIbge": 1507200,
    "latitude": -1.820738,
    "longitude": -47.75939700000001
  },
  {
    "codigo": "BR354",
    "nome": "Xambio�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "TO",
    "municipioNome": "Xambio�",
    "municipioIbge": 1722100,
    "latitude": -6.408197,
    "longitude": -48.537602
  },
  {
    "codigo": "BR355",
    "nome": "Barra do Quara�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "Barra do Quara�",
    "municipioIbge": 4301870,
    "latitude": -30.20846,
    "longitude": -57.555561
  },
  {
    "codigo": "BR356",
    "nome": "Porto Mau�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "Porto Mau�",
    "municipioIbge": 4315050,
    "latitude": -27.574999,
    "longitude": -54.667999
  },
  {
    "codigo": "BR361",
    "nome": "Chaves",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Chaves",
    "municipioIbge": 1502500,
    "latitude": -0.166562,
    "longitude": -49.981638
  },
  {
    "codigo": "BR364",
    "nome": "Curralinho",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Curralinho",
    "municipioIbge": 1502800,
    "latitude": -1.810287,
    "longitude": -49.799894
  },
  {
    "codigo": "BR365",
    "nome": "Terminal Floresta",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "SP",
    "municipioNome": "Iacanga",
    "municipioIbge": 3519100,
    "latitude": -21.854722,
    "longitude": -48.968333
  },
  {
    "codigo": "BR366",
    "nome": "Terminal S�o Miguel",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "SP",
    "municipioNome": "Borac�ia",
    "municipioIbge": 3507300,
    "latitude": -22.217777,
    "longitude": -48.74361100000001
  },
  {
    "codigo": "BR367",
    "nome": "Terminal Fazenda S�o Joaquim",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "SP",
    "municipioNome": "Ja�",
    "municipioIbge": 3525300,
    "latitude": -22.429999,
    "longitude": -48.660555
  },
  {
    "codigo": "BR368",
    "nome": "Eclusa Tiet� Montante",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "SP",
    "municipioNome": "Igara�u do Tiet�",
    "municipioIbge": 3520000,
    "latitude": -22.522222,
    "longitude": -48.53527700000001
  },
  {
    "codigo": "BR369",
    "nome": "Usina Diamante",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "SP",
    "municipioNome": "Ja�",
    "municipioIbge": 3525300,
    "latitude": -22.372084,
    "longitude": -48.691034
  },
  {
    "codigo": "BR370",
    "nome": "Usina Pioneiros",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "SP",
    "municipioNome": "Sud Mennucci",
    "municipioIbge": 3552300,
    "latitude": -20.733888,
    "longitude": -50.96555500000001
  },
  {
    "codigo": "BR371",
    "nome": "Santa Terezinha",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PR",
    "municipioNome": "Foz do Igua�u",
    "municipioIbge": 4108300,
    "latitude": -25.366111,
    "longitude": -54.501388
  },
  {
    "codigo": "BR372",
    "nome": "Eclusa Tiet� Jusante",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "SP",
    "municipioNome": "Ilha Solteira",
    "municipioIbge": 3520440,
    "latitude": -20.673611,
    "longitude": -51.319166
  },
  {
    "codigo": "BR373",
    "nome": "Mundo Novo",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "MS",
    "municipioNome": "Mundo Novo",
    "municipioIbge": 5005680,
    "latitude": -24.044444,
    "longitude": -54.276388
  },
  {
    "codigo": "BR374",
    "nome": "S�o Pedro",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "SP",
    "municipioNome": "S�o Pedro",
    "municipioIbge": 3550400,
    "latitude": -22.651666,
    "longitude": -48.029444
  },
  {
    "codigo": "BR375",
    "nome": "Terra Roxa",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PR",
    "municipioNome": "Terra Roxa",
    "municipioIbge": 4127400,
    "latitude": -24.064072,
    "longitude": -54.16461
  },
  {
    "codigo": "BR901",
    "nome": "Bacia Sedimentar do Cear�",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -1.293055,
    "longitude": -39.531944
  },
  {
    "codigo": "BR902",
    "nome": "Bacia Sedimentar da Foz do Amazonas",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": 1.811671,
    "longitude": -47.08621300000001
  },
  {
    "codigo": "BR903",
    "nome": "Bacia Sedimentar Par�-Maranh�o",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -0.239999,
    "longitude": -44.864166
  },
  {
    "codigo": "BR904",
    "nome": "Bacia Sedimentar Potiguar",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -3.420277,
    "longitude": -36.541111
  },
  {
    "codigo": "BR905",
    "nome": "Bacia Sedimentar Pernambuco-Para�ba",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -7.555277,
    "longitude": -33.463333
  },
  {
    "codigo": "BR906",
    "nome": "Bacia Sedimentar SEAL",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -11.123888,
    "longitude": -34.220833
  },
  {
    "codigo": "BR907",
    "nome": "Bacia Sedimentar de Jacu�pe",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -12.972894,
    "longitude": -35.498496
  },
  {
    "codigo": "BR908",
    "nome": "Bacia Sedimentar de Camamu-Almada",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -13.913055,
    "longitude": -37.399444
  },
  {
    "codigo": "BR909",
    "nome": "Bacia Sedimentar do Rec�ncavo",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -12.823611,
    "longitude": -38.628055
  },
  {
    "codigo": "BR911",
    "nome": "Bacia Sedimentar de Cumuruxatiba",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -16.8825,
    "longitude": -37.036111
  },
  {
    "codigo": "BR912",
    "nome": "Bacia Sedimentar de Mucuri",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -18.4375,
    "longitude": -36.422777
  },
  {
    "codigo": "BR913",
    "nome": "Bacia Sedimentar do Esp�rito Santo",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -20.514251,
    "longitude": -37.537655
  },
  {
    "codigo": "BR914",
    "nome": "Bacia Sedimentar de Pelotas",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -31.366944,
    "longitude": -47.610555
  },
  {
    "codigo": "BR915",
    "nome": "Bacia Sedimentar de Barreirinhas",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -1.081388,
    "longitude": -42.571111
  },
  {
    "codigo": "BRABO",
    "nome": "�gua Boa",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Nova Nazar�",
    "municipioIbge": 5106170,
    "latitude": -14.088334,
    "longitude": -51.698045
  },
  {
    "codigo": "BRAC001",
    "nome": "Base de Cruzeiro do Sul - BASUL II",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1200203,
    "latitude": -7.61981,
    "longitude": -72.6441
  },
  {
    "codigo": "BRAC002",
    "nome": "Porto Fluvial de Cruzeiro do Sul",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1200203,
    "latitude": -7.619,
    "longitude": -72.645
  },
  {
    "codigo": "BRAC004",
    "nome": "Porto Amaz�nia Transportes",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1200203,
    "latitude": -7.717,
    "longitude": -72.642
  },
  {
    "codigo": "BRAC005",
    "nome": "Atem's Distribuidora de Petr�leo",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1200203,
    "latitude": -7.622,
    "longitude": -72.651
  },
  {
    "codigo": "BRAC006",
    "nome": "Instala��o Portu�ria para Transbordo de Combust�vel",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1200203,
    "latitude": -7.641,
    "longitude": -72.665
  },
  {
    "codigo": "BRACT",
    "nome": "Alc�ntara",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Alc�ntara",
    "municipioIbge": 2100200,
    "latitude": -2.406509,
    "longitude": -44.4234
  },
  {
    "codigo": "BRADR",
    "nome": "Angra dos Reis �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "RJ",
    "municipioNome": "Angra dos Reis",
    "municipioIbge": 3300100,
    "latitude": -23.011943,
    "longitude": -44.316389
  },
  {
    "codigo": "BRAFU",
    "nome": "Afu�",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Afu�",
    "municipioIbge": 1500300,
    "latitude": -0.157852,
    "longitude": -50.389441
  },
  {
    "codigo": "BRAJU",
    "nome": "Aracaju",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "SE",
    "municipioNome": "Aracaju",
    "municipioIbge": 2800300,
    "latitude": -10.9059,
    "longitude": -37.047899
  },
  {
    "codigo": "BRAL001",
    "nome": "Terminal Braskem",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2704302,
    "latitude": -9.694,
    "longitude": -35.759
  },
  {
    "codigo": "BRALT",
    "nome": "Alenquer",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Alenquer",
    "municipioIbge": 1500400,
    "latitude": -1.952758,
    "longitude": -54.72673200000001
  },
  {
    "codigo": "BRAM001",
    "nome": "J. F. de Oliveira - Manaus",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.136,
    "longitude": -59.938
  },
  {
    "codigo": "BRAM003",
    "nome": "Cimento Vencemos",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.123,
    "longitude": -59.924
  },
  {
    "codigo": "BRAM004",
    "nome": "Terminal Navecunha",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.154,
    "longitude": -59.999
  },
  {
    "codigo": "BRAM005",
    "nome": "Terminal Hermasa Navega��o da Amaz�nia",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301902,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRAM006",
    "nome": "Porto Chibat�o",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.16,
    "longitude": -59.991
  },
  {
    "codigo": "BRAM007",
    "nome": "Chibat�o Navega��o e Com�rcio",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.15496,
    "longitude": -59.9932
  },
  {
    "codigo": "BRAM008",
    "nome": "TUP Ibepar",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.09203,
    "longitude": -60.0742
  },
  {
    "codigo": "BRAM009",
    "nome": "Terminal Aquavi�rio Solim�es - Coari",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301209,
    "latitude": -3.944,
    "longitude": -63.161
  },
  {
    "codigo": "BRAM010",
    "nome": "Terminal Sanave de Manaus",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.1181,
    "longitude": -60.0549
  },
  {
    "codigo": "BRAM011",
    "nome": "Terminal Aquavi�rio de Manaus",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.15,
    "longitude": -59.952
  },
  {
    "codigo": "BRAM012",
    "nome": "Super Terminais Com�rcio e Ind�stria",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.157,
    "longitude": -59.999
  },
  {
    "codigo": "BRAM013",
    "nome": "TUP Ocrim",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.15107,
    "longitude": -60.0058
  },
  {
    "codigo": "BRAM014",
    "nome": "Terminal Graneleiro Hermasa",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301902,
    "latitude": -3.136,
    "longitude": -58.484
  },
  {
    "codigo": "BRAM015",
    "nome": "TUP Carinhoso",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.111,
    "longitude": -59.901
  },
  {
    "codigo": "BRAM016",
    "nome": "TUP Moss",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.154,
    "longitude": -60
  },
  {
    "codigo": "BRAM017",
    "nome": "ATR Log�stica - Chibat�o",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.157,
    "longitude": -59.996
  },
  {
    "codigo": "BRAM018",
    "nome": "Itacal- Itacoatiara Calc�rios Ltda",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.09456,
    "longitude": -60.0772
  },
  {
    "codigo": "BRAM019",
    "nome": "TNA ITAUTINGA",
    "tipo": "TNA",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -3.1625,
    "longitude": -59.98
  },
  {
    "codigo": "BRAM021",
    "nome": "ATEM Manaus",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.149,
    "longitude": -59.959
  },
  {
    "codigo": "BRAM022",
    "nome": "TNA PETROLEO SABBA MANAUS",
    "tipo": "TNA",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -3.147607,
    "longitude": -59.950704
  },
  {
    "codigo": "BRAM023",
    "nome": "TNA PETROBRAS MANAUS",
    "tipo": "TNA",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -3.148931,
    "longitude": -59.952057
  },
  {
    "codigo": "BRAM024",
    "nome": "TNA IPIRANGA MANAUS",
    "tipo": "TNA",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -3.150242,
    "longitude": -59.958558
  },
  {
    "codigo": "BRAM025",
    "nome": "Terminais Fluviais do Brasil",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301902,
    "latitude": -3.15167,
    "longitude": -58.4328
  },
  {
    "codigo": "BRAM026",
    "nome": "Uni�o Transportes",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.134,
    "longitude": -59.939
  },
  {
    "codigo": "BRAM028",
    "nome": "Ronav",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.1326,
    "longitude": -59.9383
  },
  {
    "codigo": "BRAM029",
    "nome": "Esta��o EAG - Bertolini",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.1175,
    "longitude": -59.9128
  },
  {
    "codigo": "BRAM031",
    "nome": "Porto do Dem�trio",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.147,
    "longitude": -60.009
  },
  {
    "codigo": "BRAM032",
    "nome": "J A Leite Navega��o",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.11924,
    "longitude": -60.0501
  },
  {
    "codigo": "BRAM034",
    "nome": "Ipiranga Manaus",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.15202,
    "longitude": -59.9585
  },
  {
    "codigo": "BRAM039",
    "nome": "J. F. de Oliveira Humait�",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301704,
    "latitude": -7.494,
    "longitude": -63.023
  },
  {
    "codigo": "BRAM057",
    "nome": "Porto da JG",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1304062,
    "latitude": -4.232,
    "longitude": -69.943
  },
  {
    "codigo": "BRAM063",
    "nome": "Transale",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.134,
    "longitude": -59.939
  },
  {
    "codigo": "BRAM065",
    "nome": "Porto Amazong�s",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.135,
    "longitude": -59.939
  },
  {
    "codigo": "BRAM066",
    "nome": "Porto do Cimento",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.153,
    "longitude": -60
  },
  {
    "codigo": "BRAM067",
    "nome": "Porto Voyager",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1304062,
    "latitude": -4.233,
    "longitude": -69.944
  },
  {
    "codigo": "BRAM069",
    "nome": "Ponta Negra",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.095,
    "longitude": -60.075
  },
  {
    "codigo": "BRAM070",
    "nome": "Centro de Embarca��es do Comando Militar da Amaz�nia",
    "tipo": "Registro - Instala��o tempor�ria",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.086,
    "longitude": -60.082
  },
  {
    "codigo": "BRAM071",
    "nome": "Porto Cheuan",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.122,
    "longitude": -60.046
  },
  {
    "codigo": "BRAM072",
    "nome": "Porto Encontro das �guas",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.118,
    "longitude": -59.914
  },
  {
    "codigo": "BRAM073",
    "nome": "Porto de Democracia",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302702,
    "latitude": -5.799,
    "longitude": -61.43
  },
  {
    "codigo": "BRAM074",
    "nome": "Porto Democracia",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302702,
    "latitude": -5.79936,
    "longitude": -61.4297
  },
  {
    "codigo": "BRAM075",
    "nome": "Rio Amazonas Terminais e Empreendimentos",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.082,
    "longitude": -59.858
  },
  {
    "codigo": "BRAM077",
    "nome": "Porto 3R",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.148,
    "longitude": -60.008
  },
  {
    "codigo": "BRAM078",
    "nome": "Porto Trairi",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.117,
    "longitude": -60.054
  },
  {
    "codigo": "BRAM079",
    "nome": "Ciagram Portos e Navega��o da Amaz�nia",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301704,
    "latitude": -7.48513,
    "longitude": -63.0257
  },
  {
    "codigo": "BRAM081",
    "nome": "Porto Brasilit",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.11939,
    "longitude": -60.0501
  },
  {
    "codigo": "BRAM082",
    "nome": "Estaleiro Bibi Eireli",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.161,
    "longitude": -59.982
  },
  {
    "codigo": "BRAM083",
    "nome": "El Shadai",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301704,
    "latitude": -7.483,
    "longitude": -63.026
  },
  {
    "codigo": "BRAM086",
    "nome": "Navega��o N�brega",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.159,
    "longitude": -59.985
  },
  {
    "codigo": "BRAM087",
    "nome": "Amazon A�o Ind�stria e Com�rcio Ltda",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.07771,
    "longitude": -59.8551
  },
  {
    "codigo": "BRAM088",
    "nome": "Terminal Distribuidora Equador Manaus",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.14456,
    "longitude": -59.9598
  },
  {
    "codigo": "BRAM089",
    "nome": "Navega��o Rio Negro S/A",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.148,
    "longitude": -59.965
  },
  {
    "codigo": "BRAM090",
    "nome": "COOP-ACAMDAF",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.053,
    "longitude": -60.109
  },
  {
    "codigo": "BRAM091",
    "nome": "Terminal Portu�rio Novo Remanso",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301902,
    "latitude": -3.228,
    "longitude": -59.008
  },
  {
    "codigo": "BRAM092",
    "nome": "Beconal",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.096,
    "longitude": -60.073
  },
  {
    "codigo": "BRAM093",
    "nome": "Estaleiro Juru�",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301852,
    "latitude": -3.15,
    "longitude": -60.097
  },
  {
    "codigo": "BRAM095",
    "nome": "Porto Santa Rosa",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1303403,
    "latitude": -2.636,
    "longitude": -56.757
  },
  {
    "codigo": "BRAM096",
    "nome": "Porto Socorro Carvalho",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.119,
    "longitude": -59.922
  },
  {
    "codigo": "BRAM097",
    "nome": "Porto Juarez Prates",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301852,
    "latitude": -3.152,
    "longitude": -60.1
  },
  {
    "codigo": "BRAM098",
    "nome": "Porto Galo da Serra",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.147,
    "longitude": -59.963
  },
  {
    "codigo": "BRAM099",
    "nome": "IP4 Itacoatiara",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301902,
    "latitude": -3.14729,
    "longitude": -58.4492
  },
  {
    "codigo": "BRAM100",
    "nome": "IP4 Tabatinga",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1304062,
    "latitude": -4.2346,
    "longitude": -69.9446
  },
  {
    "codigo": "BRAM101",
    "nome": "Estaleiro Helitec",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.102,
    "longitude": -60.072
  },
  {
    "codigo": "BRAM103",
    "nome": "Expresso Alian�a Mudan�as, Transportes e Servi�os Ltda",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.093,
    "longitude": -60.076
  },
  {
    "codigo": "BRAM104",
    "nome": "Bemar III",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.15254,
    "longitude": -59.958
  },
  {
    "codigo": "BRAM105",
    "nome": "Estaleiro Xpressboat",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.054,
    "longitude": -59.841
  },
  {
    "codigo": "BRAM106",
    "nome": "Porto Juarez Prates II",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301852,
    "latitude": -3.151,
    "longitude": -60.099
  },
  {
    "codigo": "BRAM107",
    "nome": "IP4 do Munic�pio de Autazes/AM",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300300,
    "latitude": -3.577,
    "longitude": -59.134
  },
  {
    "codigo": "BRAM108",
    "nome": "IP4 do Munic�pio de Barreirinha/AM",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300508,
    "latitude": -2.793,
    "longitude": -57.073
  },
  {
    "codigo": "BRAM109",
    "nome": "IP4 do Munic�pio de Benjamin Constant",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300607,
    "latitude": -4.373,
    "longitude": -70.028
  },
  {
    "codigo": "BRAM110",
    "nome": "IP4 de Beruri",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300631,
    "latitude": -3.898,
    "longitude": -61.376
  },
  {
    "codigo": "BRAM111",
    "nome": "IP4 de Boa Vista do Ramos",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300680,
    "latitude": -2.969,
    "longitude": -57.589
  },
  {
    "codigo": "BRAM112",
    "nome": "IP4 de Borba",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300805,
    "latitude": -4.385,
    "longitude": -59.593
  },
  {
    "codigo": "BRAM113",
    "nome": "IP4 de Canutama",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300904,
    "latitude": -6.54,
    "longitude": -64.387
  },
  {
    "codigo": "BRAM114",
    "nome": "IP4 de Carauari",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301001,
    "latitude": -4.884,
    "longitude": -66.9
  },
  {
    "codigo": "BRAM115",
    "nome": "IP4 de Careiro de V�rzea",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301159,
    "latitude": -3.189,
    "longitude": -59.868
  },
  {
    "codigo": "BRAM116",
    "nome": "IP4 de Coari",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301209,
    "latitude": -4.082,
    "longitude": -63.143
  },
  {
    "codigo": "BRAM117",
    "nome": "IP4 de Codaj�s",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301308,
    "latitude": -3.844,
    "longitude": -62.063
  },
  {
    "codigo": "BRAM118",
    "nome": "IP4 de Eirunep�",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301407,
    "latitude": -6.668,
    "longitude": -69.867
  },
  {
    "codigo": "BRAM119",
    "nome": "IP4 de Fonte Boa",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301605,
    "latitude": -2.496,
    "longitude": -66.068
  },
  {
    "codigo": "BRAM120",
    "nome": "IP4 de Guajar�",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301654,
    "latitude": -7.548,
    "longitude": -72.579
  },
  {
    "codigo": "BRAM121",
    "nome": "IP4 de Humait�",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301704,
    "latitude": -7.509,
    "longitude": -63.019
  },
  {
    "codigo": "BRAM122",
    "nome": "Pont�o Bons Amigos",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.14459,
    "longitude": -60.0218
  },
  {
    "codigo": "BRAM123",
    "nome": "Pont�o L J",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.14767,
    "longitude": -60.014
  },
  {
    "codigo": "BRAM124",
    "nome": "Pont�o Quadros Filho",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.14583,
    "longitude": -60.0186
  },
  {
    "codigo": "BRAM125",
    "nome": "IP4 de Ipixuna",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301803,
    "latitude": -7.055,
    "longitude": -71.689
  },
  {
    "codigo": "BRAM126",
    "nome": "IP4 de Iranduba",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301852,
    "latitude": -3.291,
    "longitude": -60.19
  },
  {
    "codigo": "BRAM128",
    "nome": "IP4 de Itamarati",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301951,
    "latitude": -6.442,
    "longitude": -68.239
  },
  {
    "codigo": "BRAM129",
    "nome": "IP4 de Itapiranga",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302009,
    "latitude": -2.75,
    "longitude": -58.022
  },
  {
    "codigo": "BRAM130",
    "nome": "IP4 de Manacapuru",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302504,
    "latitude": -3.295,
    "longitude": -60.637
  },
  {
    "codigo": "BRAM131",
    "nome": "IP4 de Manaquiri",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302553,
    "latitude": -3.427,
    "longitude": -60.459
  },
  {
    "codigo": "BRAM132",
    "nome": "IP4 de Manicor�",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302702,
    "latitude": -5.804,
    "longitude": -61.299
  },
  {
    "codigo": "BRAM133",
    "nome": "IP4 de Mau�s",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302900,
    "latitude": -3.382,
    "longitude": -57.724
  },
  {
    "codigo": "BRAM134",
    "nome": "IP4 de Nhamund�",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1303007,
    "latitude": -2.187,
    "longitude": -56.713
  },
  {
    "codigo": "BRAM135",
    "nome": "IP4 de Nova Olinda",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1303106,
    "latitude": -3.887,
    "longitude": -59.091
  },
  {
    "codigo": "BRAM136",
    "nome": "IP4 de Novo Air�o",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1303205,
    "latitude": -2.621,
    "longitude": -60.946
  },
  {
    "codigo": "BRAM137",
    "nome": "IP4 de Novo Aripuan�",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1303304,
    "latitude": -5.115,
    "longitude": -60.374
  },
  {
    "codigo": "BRAM138",
    "nome": "IP4 de Parintins",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1303403,
    "latitude": -2.624,
    "longitude": -56.734
  },
  {
    "codigo": "BRAM139",
    "nome": "IP4 de Santa Isabel do Rio Negro",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1303601,
    "latitude": -0.417,
    "longitude": -65.02
  },
  {
    "codigo": "BRAM140",
    "nome": "IP4 de S�o Raimundo",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.125,
    "longitude": -60.042
  },
  {
    "codigo": "BRAM141",
    "nome": "IP4 de S�o Sebasti�o do Uatum�",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1303957,
    "latitude": -2.573,
    "longitude": -57.87
  },
  {
    "codigo": "BRAM142",
    "nome": "IP4 de S�o Paulo de Oliven�a",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1303908,
    "latitude": -3.462,
    "longitude": -68.958
  },
  {
    "codigo": "BRAM144",
    "nome": "IP4 de Tapau�",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1304104,
    "latitude": -5.618,
    "longitude": -63.186
  },
  {
    "codigo": "BRAM145",
    "nome": "IP4 de Tonantins",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1304237,
    "latitude": -2.862,
    "longitude": -67.771
  },
  {
    "codigo": "BRAM146",
    "nome": "IP4 de Urucar�",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1304302,
    "latitude": -2.54,
    "longitude": -57.751
  },
  {
    "codigo": "BRAM147",
    "nome": "IP4 de Urucurituba",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1304401,
    "latitude": -3.123,
    "longitude": -58.159
  },
  {
    "codigo": "BRAM148",
    "nome": "Itaipava - Manaus",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.118,
    "longitude": -59.923
  },
  {
    "codigo": "BRAM149",
    "nome": "Porto da Prainha",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1304062,
    "latitude": -4.238,
    "longitude": -69.945
  },
  {
    "codigo": "BRAM150",
    "nome": "Balsa Cuiab�",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301902,
    "latitude": -3.151,
    "longitude": -58.512
  },
  {
    "codigo": "BRAM152",
    "nome": "Potassio do Brasil",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300300,
    "latitude": -3.546,
    "longitude": -58.922
  },
  {
    "codigo": "BRAM154",
    "nome": "ERAM - Estaleiro Rio Amazonas",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.121,
    "longitude": -60.047
  },
  {
    "codigo": "BRAM155",
    "nome": "Petr�leo Sabb� - Terminal Manaus",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.148,
    "longitude": -59.95
  },
  {
    "codigo": "BRAM156",
    "nome": "Porto Afonso",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301209,
    "latitude": -4.085,
    "longitude": -63.138
  },
  {
    "codigo": "BRAM163",
    "nome": "Pont�o Coari",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301209,
    "latitude": -4.07869,
    "longitude": -63.1422
  },
  {
    "codigo": "BRAM167",
    "nome": "CS Constru��o e Navega��o",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.09057,
    "longitude": -59.8883
  },
  {
    "codigo": "BRAM168",
    "nome": "Pont�o Menezes",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.14824,
    "longitude": -60.0125
  },
  {
    "codigo": "BRAM169",
    "nome": "Chibat�o Navega��o e Com�rcio Ltda - TUP Alfandegado",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.15591,
    "longitude": -59.9902
  },
  {
    "codigo": "BRAM170",
    "nome": "Cemopar Cer�mica Moderna de Parintins Ind. e Com. LTDA",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1303403,
    "latitude": -2.62389,
    "longitude": -56.7222
  },
  {
    "codigo": "BRAM171",
    "nome": "Serraria Boa Vista",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1303403,
    "latitude": -2.62257,
    "longitude": -56.721
  },
  {
    "codigo": "BRAM172",
    "nome": "Hermasa Navega��o da Amaz�nia Ltda (Estaleiro)",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300000,
    "latitude": -3.15083,
    "longitude": -58.44
  },
  {
    "codigo": "BRAM173",
    "nome": "LIMPAR NAVEGA��O E SERVI�OS EIRELI",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1303403,
    "latitude": -2.62,
    "longitude": -56.72
  },
  {
    "codigo": "BRAM174",
    "nome": "Uni�o Transportes",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.33767,
    "longitude": -59.939
  },
  {
    "codigo": "BRAM175",
    "nome": "PONT�O SABINO COMBUST�VEIS",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1304237,
    "latitude": -2.86155,
    "longitude": -67.7698
  },
  {
    "codigo": "BRAM176",
    "nome": "E B Braulio Constru��es LTDA",
    "tipo": "Registro - Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.08734,
    "longitude": -60.0467
  },
  {
    "codigo": "BRAM177",
    "nome": "IP4 de Vila Amazonia",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1303403,
    "latitude": -2.61164,
    "longitude": -56.668
  },
  {
    "codigo": "BRAM178",
    "nome": "Instala��o Portu�ria P�blica de Pequeno Porte � IP4 � de Alvar�es",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300029,
    "latitude": -3.2109,
    "longitude": -64.8044
  },
  {
    "codigo": "BRAM179",
    "nome": "Instala��o Portu�ria P�blica de Pequeno Porte � IP4 � de Japur�",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302108,
    "latitude": -1.87737,
    "longitude": -66.9971
  },
  {
    "codigo": "BRAM183",
    "nome": "IP4 de Silves",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1304005,
    "latitude": -2.82521,
    "longitude": -58.2244
  },
  {
    "codigo": "BRAM184",
    "nome": "Porto Sales Nave",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.11101,
    "longitude": -60.0654
  },
  {
    "codigo": "BRAM190",
    "nome": "Porto Sabi�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1304062,
    "latitude": -4.24041,
    "longitude": -69.9457
  },
  {
    "codigo": "BRAM195",
    "nome": "Terminal Portu�rio das Lajes",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.11034,
    "longitude": -59.8986
  },
  {
    "codigo": "BRAM196",
    "nome": "Porto W Pereira",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.10517,
    "longitude": -60.0709
  },
  {
    "codigo": "BRAM197",
    "nome": "CAIAMBE CONSTRU��ES",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300000,
    "latitude": -3.12592,
    "longitude": -60.0425
  },
  {
    "codigo": "BRAM199",
    "nome": "Porto Enseada Marapat�-PEM",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.15433,
    "longitude": -59.9741
  },
  {
    "codigo": "BRAM200",
    "nome": "POSTO FLUTUANTE (PONT�O)",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.04569,
    "longitude": -60.1129
  },
  {
    "codigo": "BRAM201",
    "nome": "PONT�O MANAUS",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.14517,
    "longitude": -60.0203
  },
  {
    "codigo": "BRAM202",
    "nome": "ERAM ESTALEIRO RIO AMAZONAS LTDA",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -2.96054,
    "longitude": -60.1155
  },
  {
    "codigo": "BRAM204",
    "nome": "Pont�o Viana",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Constru��o Conclu�da",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.14824,
    "longitude": -60.0124
  },
  {
    "codigo": "BRAM207",
    "nome": "Balsa Vermelha",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.14188,
    "longitude": -60.0211
  },
  {
    "codigo": "BRAM208",
    "nome": "Porto Volki",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301704,
    "latitude": -7.51523,
    "longitude": -63.0173
  },
  {
    "codigo": "BRAM214",
    "nome": "Pont�o Bons Amigos II",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Constru��o Conclu�da",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.13451,
    "longitude": -59.9351
  },
  {
    "codigo": "BRAM215",
    "nome": "Pont�o Amazonas XXV",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Constru��o Conclu�da",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300000,
    "latitude": -4.0784,
    "longitude": -63.1417
  },
  {
    "codigo": "BRAM216",
    "nome": "Pont�o Souza",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302603,
    "latitude": -3.13249,
    "longitude": -60.0391
  },
  {
    "codigo": "BRAM219",
    "nome": "IP4 Porto de Anori",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300000,
    "latitude": -3.7597,
    "longitude": -61.6445
  },
  {
    "codigo": "BRAM220",
    "nome": "Porto Soares",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300000,
    "latitude": -3.15119,
    "longitude": -58.4396
  },
  {
    "codigo": "BRAM223",
    "nome": "Terminal Ajato",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1300000,
    "latitude": -3.14028,
    "longitude": -60.0245
  },
  {
    "codigo": "BRAM224",
    "nome": "Pont�o Leiliane VII",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1302553,
    "latitude": -3.42497,
    "longitude": -60.4574
  },
  {
    "codigo": "BRAM225",
    "nome": "Terminais de Gran�is L�quidos Novo Remanso (TGL Novo Remanso)",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301902,
    "latitude": -3.22986,
    "longitude": -58.9933
  },
  {
    "codigo": "BRAM226",
    "nome": "Terminal Carga Geral e Gran�is S�lidos Minerais Novo Remanso (TCG/TGSM Novo Remanso)",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1301902,
    "latitude": -3.22759,
    "longitude": -59.0045
  },
  {
    "codigo": "BRAMM",
    "nome": "Almeirim",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Almeirim",
    "municipioIbge": 1500500,
    "latitude": -1.532469,
    "longitude": -52.576897
  },
  {
    "codigo": "BRANA",
    "nome": "Ananindeua",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Ananindeua",
    "municipioIbge": 1500800,
    "latitude": -1.32,
    "longitude": -48.379
  },
  {
    "codigo": "BRANT",
    "nome": "Antonina",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "PR",
    "municipioNome": "Antonina",
    "municipioIbge": 4101200,
    "latitude": -25.444167,
    "longitude": -48.69333300000001
  },
  {
    "codigo": "BRAP003",
    "nome": "ETC Bertolini - Santana",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600600,
    "latitude": -0.003,
    "longitude": -51.203
  },
  {
    "codigo": "BRAP004",
    "nome": "Terminal Privativo Zamin Ferrous Sistema Amap�",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600600,
    "latitude": -0.057,
    "longitude": -51.182
  },
  {
    "codigo": "BRAP005",
    "nome": "TNA TEXACO MACAP�",
    "tipo": "TNA",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -0.056801,
    "longitude": -51.184709
  },
  {
    "codigo": "BRAP006",
    "nome": "Terminal Cianport Santana",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600600,
    "latitude": -0.068333,
    "longitude": -51.16
  },
  {
    "codigo": "BRAP007",
    "nome": "Porto Belnave I",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600105,
    "latitude": -0.007,
    "longitude": -51.201
  },
  {
    "codigo": "BRAP008",
    "nome": "Reicon Santana",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600600,
    "latitude": -0.0546539,
    "longitude": -51.1814
  },
  {
    "codigo": "BRAP012",
    "nome": "Porto do Grego",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600600,
    "latitude": -0.06,
    "longitude": -51.167
  },
  {
    "codigo": "BRAP017",
    "nome": "Itaipava S/A",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600600,
    "latitude": -0.008,
    "longitude": -51.201
  },
  {
    "codigo": "BRAP018",
    "nome": "Terminal Hidrovi�rio S�o Benedito",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600600,
    "latitude": -0.058,
    "longitude": -51.175
  },
  {
    "codigo": "BRAP019",
    "nome": "TERMINAL DE MACAPA",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600600,
    "latitude": -0.41592,
    "longitude": -51.1812
  },
  {
    "codigo": "BRAP020",
    "nome": "Terminal Hidrovi�rio de Laranjal do Jar�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600279,
    "latitude": -0.857,
    "longitude": -52.525
  },
  {
    "codigo": "BRAP021",
    "nome": "Terminal de Gran�is L�quidos do Amap� - TGLA",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600600,
    "latitude": -0.061835,
    "longitude": -51.2045
  },
  {
    "codigo": "BRAP022",
    "nome": "Porto Silnave Santana",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600600,
    "latitude": -0.002755,
    "longitude": -51.2017
  },
  {
    "codigo": "BRAP023",
    "nome": "NORTE LOG LTDA",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600600,
    "latitude": -0.013125,
    "longitude": -51.2031
  },
  {
    "codigo": "BRAP024",
    "nome": "Retiro Primavera",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600600,
    "latitude": -0.067603,
    "longitude": -51.1469
  },
  {
    "codigo": "BRAP028",
    "nome": "Plataforma Log�stica do Amap� LTDA",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1600600,
    "latitude": -0.061835,
    "longitude": -51.2045
  },
  {
    "codigo": "BRAPY",
    "nome": "Alto Parna�ba",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Alto Parna�ba",
    "municipioIbge": 2100500,
    "latitude": -9.11386,
    "longitude": -45.92690000000001
  },
  {
    "codigo": "BRARB",
    "nome": "Aratu �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "BA",
    "municipioNome": "Candeias",
    "municipioIbge": 2906500,
    "latitude": -12.78111,
    "longitude": -38.496943
  },
  {
    "codigo": "BRARE",
    "nome": "Areia Branca �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "RN",
    "municipioNome": "Areia Branca",
    "municipioIbge": 2401100,
    "latitude": -4.817777,
    "longitude": -37.044722
  },
  {
    "codigo": "BRARS",
    "nome": "Aragar�as",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Pontal do Araguaia",
    "municipioIbge": 5106650,
    "latitude": -15.897299,
    "longitude": -52.2533
  },
  {
    "codigo": "BRARU",
    "nome": "Ara�atuba",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "SP",
    "municipioNome": "Ara�atuba",
    "municipioIbge": 3502800,
    "latitude": -21.042991,
    "longitude": -50.489094
  },
  {
    "codigo": "BRATB",
    "nome": "Abaetetuba",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "PA",
    "municipioNome": "Abaetetuba",
    "municipioIbge": 1500100,
    "latitude": -1.711,
    "longitude": -49.023
  },
  {
    "codigo": "BRATM",
    "nome": "Altamira",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Altamira",
    "municipioIbge": 1500600,
    "latitude": -3.217,
    "longitude": -52.214
  },
  {
    "codigo": "BRAUB",
    "nome": "Ita�ba",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Ita�ba",
    "municipioIbge": 5104550,
    "latitude": -11.096828,
    "longitude": -55.304581
  },
  {
    "codigo": "BRAUC",
    "nome": "Augusto Corr�a (Novo)",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "PA",
    "municipioNome": "Augusto Corr�a",
    "municipioIbge": 1500900,
    "latitude": -0.973,
    "longitude": -46.6
  },
  {
    "codigo": "BRAUN",
    "nome": "Aruan�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "GO",
    "municipioNome": "Aruan�",
    "municipioIbge": 5202500,
    "latitude": -14.9085,
    "longitude": -51.081
  },
  {
    "codigo": "BRBA001",
    "nome": "Terminal Fluvial de Juazeiro",
    "tipo": "Terminal de uso privado",
    "situacao": "INOPERANTE",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2918407,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRBA002",
    "nome": "Terminal Mar�timo Dow Aratu - Bahia",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2906501,
    "latitude": -12.783,
    "longitude": -38.476
  },
  {
    "codigo": "BRBA003",
    "nome": "Terminal Aquavi�rio de Madre de Deus",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2919926,
    "latitude": -12.754,
    "longitude": -38.624
  },
  {
    "codigo": "BRBA004",
    "nome": "Terminal de Barca�as Luciano Villas Boas Machado",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2906907,
    "latitude": -17.7514,
    "longitude": -39.2164
  },
  {
    "codigo": "BRBA005",
    "nome": "TUP TMB - Terminal Mar�timo de Belmonte",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2903409,
    "latitude": -16.03,
    "longitude": -38.924
  },
  {
    "codigo": "BRBA006",
    "nome": "Terminal Itapu�",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2927408,
    "latitude": -12.825,
    "longitude": -38.499
  },
  {
    "codigo": "BRBA007",
    "nome": "Terminal Portu�rio Cotegipe",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2927408,
    "latitude": -12.7864,
    "longitude": -38.4769
  },
  {
    "codigo": "BRBA008",
    "nome": "Terminal Mar�timo Miguel de Oliveira",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2906501,
    "latitude": -12.787,
    "longitude": -38.486
  },
  {
    "codigo": "BRBA009",
    "nome": "Terminal de Regaseifica��o de GNL da Bahia - TRBA",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2927408,
    "latitude": -12.812,
    "longitude": -38.663
  },
  {
    "codigo": "BRBA010",
    "nome": "Terminal Porto Sul",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2913606,
    "latitude": -14.6822,
    "longitude": -39.0594
  },
  {
    "codigo": "BRBA011",
    "nome": "Terminal Bamin",
    "tipo": "Terminal de uso privado",
    "situacao": "Constru��o Iniciada",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2913606,
    "latitude": -14.7009,
    "longitude": -39.085
  },
  {
    "codigo": "BRBA012",
    "nome": "TUP Enseada Naval",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2920601,
    "latitude": -12.8597,
    "longitude": -38.8346
  },
  {
    "codigo": "BRBA013",
    "nome": "Terminal MFX",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2927408,
    "latitude": -12.79,
    "longitude": -38.481
  },
  {
    "codigo": "BRBA015",
    "nome": "BRASKEM",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2906501,
    "latitude": -12.7851,
    "longitude": -38.4931
  },
  {
    "codigo": "BRBA018",
    "nome": "Bahia Terminais",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2906501,
    "latitude": -12.7709,
    "longitude": -38.4625
  },
  {
    "codigo": "BRBA019",
    "nome": "BELOV OFF-SHORE INDUSTRIAL",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2930709,
    "latitude": -12.76,
    "longitude": -38.44
  },
  {
    "codigo": "BRBA020",
    "nome": "CANTEIRO MAR�TIMO DE MAPELE - ESTALEIRO BELOV",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2930709,
    "latitude": -12.7704,
    "longitude": -38.445
  },
  {
    "codigo": "BRBA021",
    "nome": "Terminal Ba�a de Todos os Santos - TBTS",
    "tipo": "Terminal de uso privado",
    "situacao": "Constru��o Iniciada",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2906501,
    "latitude": -12.7893,
    "longitude": -38.4877
  },
  {
    "codigo": "BRBA022",
    "nome": "Terminal de Uso Privado do Estado da Bahia",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2913606,
    "latitude": -14.671,
    "longitude": -39.0648
  },
  {
    "codigo": "BRBAI",
    "nome": "Iranduba (Solim�es)",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Iranduba",
    "municipioIbge": 1301850,
    "latitude": -3.278,
    "longitude": -60.193
  },
  {
    "codigo": "BRBCR",
    "nome": "Boca do Acre",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Boca do Acre",
    "municipioIbge": 1300700,
    "latitude": -8.752,
    "longitude": -67.4
  },
  {
    "codigo": "BRBDC",
    "nome": "Barra do Corda",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Barra do Corda",
    "municipioIbge": 2101600,
    "latitude": -5.503389,
    "longitude": -45.2445
  },
  {
    "codigo": "BRBE1",
    "nome": "Bel�m �- IP4",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Bel�m",
    "municipioIbge": 1501400,
    "latitude": -1.474,
    "longitude": -48.495
  },
  {
    "codigo": "BRBEL",
    "nome": "Bel�m �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Bel�m",
    "municipioIbge": 1501400,
    "latitude": -1.445278,
    "longitude": -48.497777
  },
  {
    "codigo": "BRBJA",
    "nome": "S�o Borja",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "S�o Borja",
    "municipioIbge": 4318000,
    "latitude": -28.6233,
    "longitude": -56.0309
  },
  {
    "codigo": "BRBMI",
    "nome": "Brasil�ndia de Minas",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MG",
    "municipioNome": "Brasil�ndia de Minas",
    "municipioIbge": 3108550,
    "latitude": -17.030503,
    "longitude": -46.01492600000001
  },
  {
    "codigo": "BRBNC",
    "nome": "Bragan�a",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Bragan�a",
    "municipioIbge": 1501700,
    "latitude": -1.06024,
    "longitude": -46.75622199999999
  },
  {
    "codigo": "BRBPG",
    "nome": "Barra do Gar�as",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Barra do Gar�as",
    "municipioIbge": 5101800,
    "latitude": -15.891683,
    "longitude": -52.25436800000001
  },
  {
    "codigo": "BRBQQ",
    "nome": "Barra",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "BA",
    "municipioNome": "Barra",
    "municipioIbge": 2902700,
    "latitude": -11.091291,
    "longitude": -43.138196
  },
  {
    "codigo": "BRBRA",
    "nome": "Barreiras",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "BA",
    "municipioNome": "Barreiras",
    "municipioIbge": 2903200,
    "latitude": -12.1407,
    "longitude": -44.997799
  },
  {
    "codigo": "BRBRO",
    "nome": "Barra do Ribeiro",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "Barra do Ribeiro",
    "municipioIbge": 4301900,
    "latitude": -30.291,
    "longitude": -51.301
  },
  {
    "codigo": "BRBSS",
    "nome": "Balsas",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Balsas",
    "municipioIbge": 2101400,
    "latitude": -7.533000000000001,
    "longitude": -46.036
  },
  {
    "codigo": "BRBVB",
    "nome": "Boa Vista",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RR",
    "municipioNome": "Cant�",
    "municipioIbge": 1400170,
    "latitude": 2.816352,
    "longitude": -60.66618200000001
  },
  {
    "codigo": "BRBVS",
    "nome": "Breves",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Breves",
    "municipioIbge": 1501800,
    "latitude": -1.673,
    "longitude": -50.499
  },
  {
    "codigo": "BRCAM",
    "nome": "Bacia Sedimentar de Campos",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -24.209444,
    "longitude": -40.008513
  },
  {
    "codigo": "BRCAV",
    "nome": "Careiro da V�rzea (Novo)",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Careiro da V�rzea",
    "municipioIbge": 1301150,
    "latitude": -3.201,
    "longitude": -59.818
  },
  {
    "codigo": "BRCAW",
    "nome": "Campos",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RJ",
    "municipioNome": "Campos dos Goytacazes",
    "municipioIbge": 3301000,
    "latitude": -21.7496,
    "longitude": -41.3085
  },
  {
    "codigo": "BRCCX",
    "nome": "C�ceres",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "C�ceres",
    "municipioIbge": 5102500,
    "latitude": -16.0728,
    "longitude": -57.698
  },
  {
    "codigo": "BRCDA",
    "nome": "Codaj�s",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Codaj�s",
    "municipioIbge": 1301300,
    "latitude": -3.844,
    "longitude": -62.062
  },
  {
    "codigo": "BRCDJ",
    "nome": "Concei��o do Araguaia",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Concei��o do Araguaia",
    "municipioIbge": 1502700,
    "latitude": -8.273,
    "longitude": -49.261
  },
  {
    "codigo": "BRCDO",
    "nome": "Cabedelo �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "PB",
    "municipioNome": "Cabedelo",
    "municipioIbge": 2503200,
    "latitude": -6.973055,
    "longitude": -34.838611
  },
  {
    "codigo": "BRCE001",
    "nome": "Terminal Portu�rio do Pec�m",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2312403,
    "latitude": -3.52703,
    "longitude": -38.7965
  },
  {
    "codigo": "BRCE002",
    "nome": "Terminal Petrobras Paracuru",
    "tipo": "Terminal de uso privado",
    "situacao": "Constru��o Conclu�da",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2310209,
    "latitude": -3.4012,
    "longitude": -39.0119
  },
  {
    "codigo": "BRCE003",
    "nome": "TUP NELOG",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2303709,
    "latitude": -3.57631,
    "longitude": -38.7911
  },
  {
    "codigo": "BRCGB",
    "nome": "Cuiab�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Cuiab�",
    "municipioIbge": 5103400,
    "latitude": -15.612899,
    "longitude": -56.1364
  },
  {
    "codigo": "BRCI1",
    "nome": "Coari (Novo)",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Coari",
    "municipioIbge": 1301200,
    "latitude": -4.078,
    "longitude": -63.131
  },
  {
    "codigo": "BRCIZ",
    "nome": "Coari",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Coari",
    "municipioIbge": 1301200,
    "latitude": -4.083,
    "longitude": -63.143
  },
  {
    "codigo": "BRCLN",
    "nome": "Carolina",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Carolina",
    "municipioIbge": 2102800,
    "latitude": -7.335868999999999,
    "longitude": -47.47509900000001
  },
  {
    "codigo": "BRCMC",
    "nome": "Camocim",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "CE",
    "municipioNome": "Camocim",
    "municipioIbge": 2302600,
    "latitude": -2.902,
    "longitude": -40.841
  },
  {
    "codigo": "BRCMG",
    "nome": "Corumb�",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "MS",
    "municipioNome": "Corumb�",
    "municipioIbge": 5003200,
    "latitude": -18.997699,
    "longitude": -57.6548
  },
  {
    "codigo": "BRCMR",
    "nome": "Camet�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Camet�",
    "municipioIbge": 1502100,
    "latitude": -2.248,
    "longitude": -49.498
  },
  {
    "codigo": "BRCPU",
    "nome": "Cururupu",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Cururupu",
    "municipioIbge": 2103700,
    "latitude": -1.827,
    "longitude": -44.866
  },
  {
    "codigo": "BRCQD",
    "nome": "Charqueadas",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "Charqueadas",
    "municipioIbge": 4305350,
    "latitude": -29.94723,
    "longitude": -51.598141
  },
  {
    "codigo": "BRCQS",
    "nome": "Costa Marques",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RO",
    "municipioNome": "Costa Marques",
    "municipioIbge": 1100080,
    "latitude": -12.445,
    "longitude": -64.227
  },
  {
    "codigo": "BRCXS",
    "nome": "Caxias",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Caxias",
    "municipioIbge": 2103000,
    "latitude": -4.873689,
    "longitude": -43.359299
  },
  {
    "codigo": "BRCZS",
    "nome": "Cruzeiro do Sul",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "AC",
    "municipioNome": "Cruzeiro do Sul",
    "municipioIbge": 1200200,
    "latitude": -7.639179,
    "longitude": -72.667
  },
  {
    "codigo": "BRERN",
    "nome": "Eirunep�",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Eirunep�",
    "municipioIbge": 1301400,
    "latitude": -6.668,
    "longitude": -69.867
  },
  {
    "codigo": "BRES001",
    "nome": "Terminal de Tubar�o",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3205309,
    "latitude": -20.2881,
    "longitude": -40.2489
  },
  {
    "codigo": "BRES002",
    "nome": "Terminal Mar�timo Ponta Ubu",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3200409,
    "latitude": -20.787,
    "longitude": -40.571
  },
  {
    "codigo": "BRES003",
    "nome": "Terminal de Praia Mole",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3205309,
    "latitude": -20.296,
    "longitude": -40.233
  },
  {
    "codigo": "BRES004",
    "nome": "Terminal Mar�timo Alfandegado Privativo de Uso Misto de Praia Mole",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3205309,
    "latitude": -20.294,
    "longitude": -40.235
  },
  {
    "codigo": "BRES005",
    "nome": "Companhia Portu�ria Vila Velha - CPVV",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3205200,
    "latitude": -20.324,
    "longitude": -40.321
  },
  {
    "codigo": "BRES006",
    "nome": "Portocel - Terminal Especializado de Barra do Riacho",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3200607,
    "latitude": -19.841,
    "longitude": -40.057
  },
  {
    "codigo": "BRES007",
    "nome": "Terminal de Barca�as Oce�nicas",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3205002,
    "latitude": -20.258,
    "longitude": -40.221
  },
  {
    "codigo": "BRES008",
    "nome": "Terminal Aquavi�rio do Norte Capixaba",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3204906,
    "latitude": -18.9783,
    "longitude": -39.7361
  },
  {
    "codigo": "BRES009",
    "nome": "Prysmian",
    "tipo": "Terminal de uso privado",
    "situacao": "INOPERANTE",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3205200,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRES010",
    "nome": "Terminal Aquavi�rio de Barra do Riacho",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3200607,
    "latitude": -19.8425,
    "longitude": -40.0625
  },
  {
    "codigo": "BRES011",
    "nome": "Terminal Portu�rio Presidente Kennedy",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3204302,
    "latitude": -21.215,
    "longitude": -40.9442
  },
  {
    "codigo": "BRES013",
    "nome": "Estaleiro Jurong",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3200607,
    "latitude": -19.863,
    "longitude": -40.07
  },
  {
    "codigo": "BRES014",
    "nome": "Porto Norte Capixaba",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3203205,
    "latitude": -19.4256,
    "longitude": -39.7169
  },
  {
    "codigo": "BRES015",
    "nome": "Terminal Industrial Imetame",
    "tipo": "Terminal de uso privado",
    "situacao": "Constru��o Iniciada",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3200607,
    "latitude": -19.8581,
    "longitude": -40.0692
  },
  {
    "codigo": "BRES020",
    "nome": "Terminal Portu�rio da Gl�ria - TPG",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3205200,
    "latitude": -20.328,
    "longitude": -40.307
  },
  {
    "codigo": "BRES022",
    "nome": "Bravamar Servi�os Mar�timos Ltda",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3205309,
    "latitude": -20.318,
    "longitude": -40.314
  },
  {
    "codigo": "BRES023",
    "nome": "TUP Zemax",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3205309,
    "latitude": -20.32,
    "longitude": -40.306
  },
  {
    "codigo": "BRES024",
    "nome": "Sea Wolf Solu��es Mar�timas",
    "tipo": "Registro - Estaleiro at� 1.000 TPB",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3205200,
    "latitude": -20.3281,
    "longitude": -40.3068
  },
  {
    "codigo": "BRES025",
    "nome": "Porto Central Complexo Industrial e Portu�rio S.A.",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3204302,
    "latitude": -21.2247,
    "longitude": -40.9472
  },
  {
    "codigo": "BRES027",
    "nome": "Itaoca Offshore",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3202801,
    "latitude": -20.982,
    "longitude": -40.812
  },
  {
    "codigo": "BRES030",
    "nome": "Hidroport Servi�os Mar�timos Ltda - ME",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3205200,
    "latitude": -20.328,
    "longitude": -40.307
  },
  {
    "codigo": "BRES031",
    "nome": "Marina da Gl�ria",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3205200,
    "latitude": -20.328,
    "longitude": -40.308
  },
  {
    "codigo": "BRES032",
    "nome": "Navemestra Servi�os de Navega��o Ltda",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3205309,
    "latitude": -20.318,
    "longitude": -40.299
  },
  {
    "codigo": "BRES033",
    "nome": "CPSM - Centro Portu�rio de S�o Mateus",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3204906,
    "latitude": -19.0657,
    "longitude": -39.722
  },
  {
    "codigo": "BRETL",
    "nome": "Estrela",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "RS",
    "municipioNome": "Estrela",
    "municipioIbge": 4307800,
    "latitude": -29.47361,
    "longitude": -51.959443
  },
  {
    "codigo": "BRFEJ",
    "nome": "Feij�",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "AC",
    "municipioNome": "Feij�",
    "municipioIbge": 1200300,
    "latitude": -8.163999,
    "longitude": -70.353999
  },
  {
    "codigo": "BRFEN",
    "nome": "Fernando de Noronha",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PE",
    "municipioNome": "Fernando de Noronha",
    "municipioIbge": 2605450,
    "latitude": -3.839999,
    "longitude": -32.411
  },
  {
    "codigo": "BRFLB",
    "nome": "Floriano",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PI",
    "municipioNome": "Floriano",
    "municipioIbge": 2203900,
    "latitude": -6.76327,
    "longitude": -43.022799
  },
  {
    "codigo": "BRFNO",
    "nome": "Forno�",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "RJ",
    "municipioNome": "Arraial do Cabo",
    "municipioIbge": 3300250,
    "latitude": -22.970278,
    "longitude": -42.015555
  },
  {
    "codigo": "BRFOR",
    "nome": "Fortaleza �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "CE",
    "municipioNome": "Fortaleza",
    "municipioIbge": 2304400,
    "latitude": -3.709722000000001,
    "longitude": -38.47361
  },
  {
    "codigo": "BRGJM",
    "nome": "Guajar�-Mirim",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "RO",
    "municipioNome": "Guajar�-Mirim",
    "municipioIbge": 1100100,
    "latitude": -10.792,
    "longitude": -65.347
  },
  {
    "codigo": "BRGMS",
    "nome": "Guimar�es",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Guimar�es",
    "municipioIbge": 2104900,
    "latitude": -2.131,
    "longitude": -44.596
  },
  {
    "codigo": "BRGO001",
    "nome": "LDC S�o Sim�o",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5220405,
    "latitude": -19.052,
    "longitude": -50.509
  },
  {
    "codigo": "BRGO008",
    "nome": "Esta��o Caramuru",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5220405,
    "latitude": -19.065,
    "longitude": -50.516
  },
  {
    "codigo": "BRGO009",
    "nome": "Caramuru Alimentos S�o Sim�o",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5220405,
    "latitude": -19.0683,
    "longitude": -50.5172
  },
  {
    "codigo": "BRGO010",
    "nome": "ETC ADM Armazens Gerais S�o Sim�o",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5220405,
    "latitude": -19.066,
    "longitude": -50.517
  },
  {
    "codigo": "BRGUR",
    "nome": "Guaruj�",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "SP",
    "municipioNome": "Guaruj�",
    "municipioIbge": 3518700,
    "latitude": -23.960899,
    "longitude": -46.293799
  },
  {
    "codigo": "BRHMA",
    "nome": "Humait�",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Humait�",
    "municipioIbge": 1301700,
    "latitude": -7.504,
    "longitude": -63.02
  },
  {
    "codigo": "BRIBB",
    "nome": "Imbituba �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "SC",
    "municipioNome": "Imbituba",
    "municipioIbge": 4207300,
    "latitude": -28.231389,
    "longitude": -48.65416700000001
  },
  {
    "codigo": "BRIBT",
    "nome": "Ibotirama",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "BA",
    "municipioNome": "Ibotirama",
    "municipioIbge": 2913200,
    "latitude": -12.186441,
    "longitude": -43.221933
  },
  {
    "codigo": "BRIGI",
    "nome": "Itagua� (Sepetiba)�",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "RJ",
    "municipioNome": "Itagua�",
    "municipioIbge": 3302000,
    "latitude": -22.930278,
    "longitude": -43.837778
  },
  {
    "codigo": "BRIGU",
    "nome": "Foz do Igua�u",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PR",
    "municipioNome": "Foz do Igua�u",
    "municipioIbge": 4108300,
    "latitude": -25.590099,
    "longitude": -54.579599
  },
  {
    "codigo": "BRIMP",
    "nome": "Imperatriz",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Imperatriz",
    "municipioIbge": 2105300,
    "latitude": -5.530669,
    "longitude": -47.4923
  },
  {
    "codigo": "BRIOS",
    "nome": "Ilh�us �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "BA",
    "municipioNome": "Ilh�us",
    "municipioIbge": 2913600,
    "latitude": -14.778332,
    "longitude": -39.026389
  },
  {
    "codigo": "BRIQI",
    "nome": "Itaqui",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "MA",
    "municipioNome": "S�o Lu�s",
    "municipioIbge": 2111300,
    "latitude": -2.578333,
    "longitude": -44.368611
  },
  {
    "codigo": "BRIRA",
    "nome": "Iturama",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MG",
    "municipioNome": "Iturama",
    "municipioIbge": 3134400,
    "latitude": -19.812902,
    "longitude": -50.18916899999999
  },
  {
    "codigo": "BRIRN",
    "nome": "Itapiranga",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Itapiranga",
    "municipioIbge": 1302000,
    "latitude": -2.75,
    "longitude": -58.022
  },
  {
    "codigo": "BRISA",
    "nome": "Ilha Solteira",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "SP",
    "municipioNome": "Ilha Solteira",
    "municipioIbge": 3520440,
    "latitude": -20.410646,
    "longitude": -51.366868
  },
  {
    "codigo": "BRITA",
    "nome": "Itacoatiara",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "AM",
    "municipioNome": "Itacoatiara",
    "municipioIbge": 1301900,
    "latitude": -3.152,
    "longitude": -58.44
  },
  {
    "codigo": "BRITB",
    "nome": "Itaituba",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Itaituba",
    "municipioIbge": 1503600,
    "latitude": -4.275239,
    "longitude": -55.98259900000001
  },
  {
    "codigo": "BRITJ",
    "nome": "Itaja��",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "SC",
    "municipioNome": "Itaja�",
    "municipioIbge": 4208200,
    "latitude": -26.90083200000001,
    "longitude": -48.666389
  },
  {
    "codigo": "BRITM",
    "nome": "Iguatama",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MG",
    "municipioNome": "Iguatama",
    "municipioIbge": 3130300,
    "latitude": -20.1731,
    "longitude": -45.715299
  },
  {
    "codigo": "BRITR",
    "nome": "Itumbiara",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "GO",
    "municipioNome": "Itumbiara",
    "municipioIbge": 5211500,
    "latitude": -18.413599,
    "longitude": -49.212299
  },
  {
    "codigo": "BRJAG",
    "nome": "Jaguar�o",
    "tipo": "Porto P�blico",
    "situacao": "Inoperante",
    "uf": "RS",
    "municipioNome": "Jaguar�o",
    "municipioIbge": 4311000,
    "latitude": -32.569088,
    "longitude": -53.375503
  },
  {
    "codigo": "BRJAU",
    "nome": "Ja�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "SP",
    "municipioNome": "Ja�",
    "municipioIbge": 3525300,
    "latitude": -22.370877,
    "longitude": -48.690106
  },
  {
    "codigo": "BRJCR",
    "nome": "Jacareacanga",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Jacareacanga",
    "municipioIbge": 1503750,
    "latitude": -6.211480999999999,
    "longitude": -57.736131
  },
  {
    "codigo": "BRJPR",
    "nome": "Ji-Paran�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RO",
    "municipioNome": "Ji-Paran�",
    "municipioIbge": 1100120,
    "latitude": -10.879786,
    "longitude": -61.94289599999999
  },
  {
    "codigo": "BRJZO",
    "nome": "Juazeiro",
    "tipo": "Porto P�blico",
    "situacao": "Inoperante",
    "uf": "BA",
    "municipioNome": "Juazeiro",
    "municipioIbge": 2918400,
    "latitude": -9.409509,
    "longitude": -40.5095
  },
  {
    "codigo": "BRLAG",
    "nome": "Laguna",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "SC",
    "municipioNome": "Laguna",
    "municipioIbge": 4209400,
    "latitude": -28.496666,
    "longitude": -48.76972199999999
  },
  {
    "codigo": "BRLAZ",
    "nome": "Bom Jesus da Lapa",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "BA",
    "municipioNome": "Bom Jesus da Lapa",
    "municipioIbge": 2903900,
    "latitude": -13.251423,
    "longitude": -43.423317
  },
  {
    "codigo": "BRLBR",
    "nome": "L�brea",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "L�brea",
    "municipioIbge": 1302400,
    "latitude": -7.257,
    "longitude": -64.794
  },
  {
    "codigo": "BRLCI",
    "nome": "Lu�s Correia",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PI",
    "municipioNome": "Lu�s Correia",
    "municipioIbge": 2205700,
    "latitude": -2.877749,
    "longitude": -41.663699
  },
  {
    "codigo": "BRLJI",
    "nome": "Laranjal do Jari",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "AP",
    "municipioNome": "Laranjal do Jari",
    "municipioIbge": 1600270,
    "latitude": -0.853148,
    "longitude": -52.53662099999999
  },
  {
    "codigo": "BRMA001",
    "nome": "Terminal Portu�rio Privativo da Alumar",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2111300,
    "latitude": -2.67833,
    "longitude": -44.3606
  },
  {
    "codigo": "BRMA002",
    "nome": "Terminal Mar�timo de Ponta da Madeira",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2111300,
    "latitude": -2.56194,
    "longitude": -44.3792
  },
  {
    "codigo": "BRMA003",
    "nome": "TUP Mearim",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2101251,
    "latitude": -2.94139,
    "longitude": -44.4303
  },
  {
    "codigo": "BRMA005",
    "nome": "Terminal Portu�rio de S�o Luis",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2111300,
    "latitude": -2.624,
    "longitude": -44.357
  },
  {
    "codigo": "BRMA006",
    "nome": "Pipes Empreendimentos Ltda",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2102804,
    "latitude": -7.334,
    "longitude": -47.476
  },
  {
    "codigo": "BRMA007",
    "nome": "Terminal Portu�rio de Alc�ntara",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2100204,
    "latitude": -2.47178,
    "longitude": -44.4905
  },
  {
    "codigo": "BRMA009",
    "nome": "Pier Flutuante &quot;GMS Base&quot;",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2111300,
    "latitude": -2.72633,
    "longitude": -44.3623
  },
  {
    "codigo": "BRMA010",
    "nome": "LC TERMINAIS GNL",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2111300,
    "latitude": -2.67095,
    "longitude": -44.3793
  },
  {
    "codigo": "BRMA011",
    "nome": "Terminal de GNL de S�o Lu�s",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2111300,
    "latitude": -2.53378,
    "longitude": -44.3779
  },
  {
    "codigo": "BRMA012",
    "nome": "BR INFRA TERMINAIS",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2111300,
    "latitude": -2.5434,
    "longitude": -44.3555
  },
  {
    "codigo": "BRMAB",
    "nome": "Marab�",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Marab�",
    "municipioIbge": 1504200,
    "latitude": -5.34731,
    "longitude": -49.135899
  },
  {
    "codigo": "BRMAO",
    "nome": "Manaus",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Manaus",
    "municipioIbge": 1302600,
    "latitude": -3.1375,
    "longitude": -60.026111
  },
  {
    "codigo": "BRMBZ",
    "nome": "Mau�s",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Mau�s",
    "municipioIbge": 1302900,
    "latitude": -3.392,
    "longitude": -57.721
  },
  {
    "codigo": "BRMCP",
    "nome": "Macap�",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "AP",
    "municipioNome": "Santana",
    "municipioIbge": 1600600,
    "latitude": -0.055555,
    "longitude": -51.166666
  },
  {
    "codigo": "BRMCU",
    "nome": "Macau",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RN",
    "municipioNome": "Macau",
    "municipioIbge": 2407200,
    "latitude": -5.104739,
    "longitude": -36.6653
  },
  {
    "codigo": "BRMCZ",
    "nome": "Macei�",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "AL",
    "municipioNome": "Macei�",
    "municipioIbge": 2704300,
    "latitude": -9.683056,
    "longitude": -35.726388
  },
  {
    "codigo": "BRMNX",
    "nome": "Manicor�",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Manicor�",
    "municipioIbge": 1302700,
    "latitude": -5.804,
    "longitude": -61.301
  },
  {
    "codigo": "BRMPR",
    "nome": "Manacapuru",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Manacapuru",
    "municipioIbge": 1302500,
    "latitude": -3.303,
    "longitude": -60.621
  },
  {
    "codigo": "BRMS001",
    "nome": "Granel Qu�mica Lad�rio",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5005202,
    "latitude": -19.0037,
    "longitude": -57.591
  },
  {
    "codigo": "BRMS002",
    "nome": "Porto Greg�rio Curvo",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5003207,
    "latitude": -19.6106,
    "longitude": -57.4578
  },
  {
    "codigo": "BRMS003",
    "nome": "Porto Sobramil",
    "tipo": "Terminal de uso privado",
    "situacao": "INOPERANTE",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5003207,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRMS004",
    "nome": "Saladeiro",
    "tipo": "Terminal de uso privado",
    "situacao": "INOPERANTE",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5003207,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRMS005",
    "nome": "Terminal Hidrovi�rio de Porto Murtinho",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5006903,
    "latitude": -21.692,
    "longitude": -57.884
  },
  {
    "codigo": "BRMS006",
    "nome": "Terminal Intermodal Cargill - Tr�s Lagoas",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5008305,
    "latitude": -20.806,
    "longitude": -51.642
  },
  {
    "codigo": "BRMS008",
    "nome": "Porto Eldorado",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5008305,
    "latitude": -20.5941,
    "longitude": -51.5899
  },
  {
    "codigo": "BRMS011",
    "nome": "Itahum Terminal",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5006903,
    "latitude": -21.7113,
    "longitude": -57.9025
  },
  {
    "codigo": "BRMS012",
    "nome": "Marina do Gelson",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5003207,
    "latitude": -18.999,
    "longitude": -57.629
  },
  {
    "codigo": "BRMS013",
    "nome": "JDS Turismo",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5005202,
    "latitude": -19,
    "longitude": -57.603
  },
  {
    "codigo": "BRMS014",
    "nome": "Phoenix Tour",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5005202,
    "latitude": -19.001,
    "longitude": -57.601
  },
  {
    "codigo": "BRMS015",
    "nome": "Porto Fluvial de Lad�rio",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5005202,
    "latitude": -19.0043,
    "longitude": -57.5915
  },
  {
    "codigo": "BRMS016",
    "nome": "Esquivel &amp; Marques Ltda.",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5000000,
    "latitude": -19.0006,
    "longitude": -57.602
  },
  {
    "codigo": "BRMS017",
    "nome": "Terminal Portu�rio Para�so",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5003207,
    "latitude": -19.5868,
    "longitude": -57.4237
  },
  {
    "codigo": "BRMS018",
    "nome": "Docas Fluvial de Porto Murtinho",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5006903,
    "latitude": -21.7134,
    "longitude": -57.9045
  },
  {
    "codigo": "BRMS019",
    "nome": "Gold Fish",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5003207,
    "latitude": -19.0002,
    "longitude": -57.6138
  },
  {
    "codigo": "BRMS020",
    "nome": "Matusalem Santana",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5005202,
    "latitude": -19.0006,
    "longitude": -57.6007
  },
  {
    "codigo": "BRMS022",
    "nome": "TUP Vetorial Log�stica",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5003207,
    "latitude": -19.0007,
    "longitude": -57.6182
  },
  {
    "codigo": "BRMT001",
    "nome": "Terminal Docas de Mato Grosso",
    "tipo": "Terminal de uso privado",
    "situacao": "INOPERANTE",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5102504,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRMT002",
    "nome": "Terminal Portu�rio Paratudal Ltda",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 5102504,
    "latitude": -16.6928,
    "longitude": -57.7614
  },
  {
    "codigo": "BRMTD",
    "nome": "Mostardas",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "Mostardas",
    "municipioIbge": 4312500,
    "latitude": -31.101628,
    "longitude": -51.11711700000001
  },
  {
    "codigo": "BRMTE",
    "nome": "Monte Alegre",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Monte Alegre",
    "municipioIbge": 1504800,
    "latitude": -2.009,
    "longitude": -54.07
  },
  {
    "codigo": "BRMTN",
    "nome": "Miracema do Tocantins",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "TO",
    "municipioNome": "Miracema do Tocantins",
    "municipioIbge": 1713200,
    "latitude": -9.5677,
    "longitude": -48.38830000000001
  },
  {
    "codigo": "BRNAT",
    "nome": "Natal",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "RN",
    "municipioNome": "Natal",
    "municipioIbge": 2408100,
    "latitude": -5.772777,
    "longitude": -35.204999
  },
  {
    "codigo": "BRNOK",
    "nome": "Nova Xavantina",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Nova Xavantina",
    "municipioIbge": 5106250,
    "latitude": -14.669237,
    "longitude": -52.354202
  },
  {
    "codigo": "BRNTR",
    "nome": "Niter�i �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "RJ",
    "municipioNome": "Niter�i",
    "municipioIbge": 3303300,
    "latitude": -22.882221,
    "longitude": -43.11611
  },
  {
    "codigo": "BRNVP",
    "nome": "Novo Aripuan�",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Novo Aripuan�",
    "municipioIbge": 1303300,
    "latitude": -5.119,
    "longitude": -60.379
  },
  {
    "codigo": "BROBI",
    "nome": "�bidos",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "�bidos",
    "municipioIbge": 1505100,
    "latitude": -1.902689,
    "longitude": -55.531199
  },
  {
    "codigo": "BRORX",
    "nome": "Oriximin�",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "PA",
    "municipioNome": "Oriximin�",
    "municipioIbge": 1505300,
    "latitude": -1.764,
    "longitude": -55.872
  },
  {
    "codigo": "BROYK",
    "nome": "Oiapoque",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AP",
    "municipioNome": "Oiapoque",
    "municipioIbge": 1600500,
    "latitude": 3.823604,
    "longitude": -51.860789
  },
  {
    "codigo": "BRPA001",
    "nome": "Terminal Trombetas",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1505304,
    "latitude": -1.46,
    "longitude": -56.38
  },
  {
    "codigo": "BRPA002",
    "nome": "Terminal Fluvial Caulim",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500503,
    "latitude": -0.918285,
    "longitude": -52.4242
  },
  {
    "codigo": "BRPA004",
    "nome": "Porto Jari - Terminal Munguba",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500503,
    "latitude": -0.926062,
    "longitude": -52.4328
  },
  {
    "codigo": "BRPA005",
    "nome": "Terminal Ponta da Montanha",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501303,
    "latitude": -1.57376,
    "longitude": -48.7771
  },
  {
    "codigo": "BRPA006",
    "nome": "Porto Murucupi",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501303,
    "latitude": -1.567,
    "longitude": -48.779
  },
  {
    "codigo": "BRPA008",
    "nome": "Mainardi",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501808,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRPA012",
    "nome": "Madenorte",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501808,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRPA013",
    "nome": "TUP J F de Oliveira de Bel�m",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.35614,
    "longitude": -48.4814
  },
  {
    "codigo": "BRPA014",
    "nome": "Porto CRA",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.334,
    "longitude": -48.485
  },
  {
    "codigo": "BRPA016",
    "nome": "TUP Bertolini - Bel�m",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.351,
    "longitude": -48.481
  },
  {
    "codigo": "BRPA017",
    "nome": "TUP Bertolini - Santar�m",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.42673,
    "longitude": -54.6955
  },
  {
    "codigo": "BRPA018",
    "nome": "Terminal Portu�rio Graneleiro de Barcarena",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501303,
    "latitude": -1.496,
    "longitude": -48.727
  },
  {
    "codigo": "BRPA019",
    "nome": "Terminal Fluvial de Juruti",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503903,
    "latitude": -2.17378,
    "longitude": -56.106
  },
  {
    "codigo": "BRPA026",
    "nome": "Magebr�s",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501808,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRPA028",
    "nome": "Base Ipiranga Santar�m",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.426,
    "longitude": -54.696
  },
  {
    "codigo": "BRPA029",
    "nome": "Majonav",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.281,
    "longitude": -48.449
  },
  {
    "codigo": "BRPA030",
    "nome": "TNA ITAITUBA",
    "tipo": "TNA",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -4.27766,
    "longitude": -55.985935
  },
  {
    "codigo": "BRPA033",
    "nome": "Porto Crai",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1507953,
    "latitude": -2.5035,
    "longitude": -48.9901
  },
  {
    "codigo": "BRPA034",
    "nome": "Porto CPA",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500206,
    "latitude": -2.254,
    "longitude": -48.586
  },
  {
    "codigo": "BRPA036",
    "nome": "Esta��o Juruti",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503903,
    "latitude": -2.162,
    "longitude": -56.101
  },
  {
    "codigo": "BRPA037",
    "nome": "Terminal Buritirama - Barcarena",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501303,
    "latitude": -1.573,
    "longitude": -48.7712
  },
  {
    "codigo": "BRPA038",
    "nome": "ETC Miritituba",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.27389,
    "longitude": -55.9506
  },
  {
    "codigo": "BRPA039",
    "nome": "G. C. Rodrigues",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.431,
    "longitude": -48.493
  },
  {
    "codigo": "BRPA040",
    "nome": "PORTO EMAPA",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500305,
    "latitude": -0.16394,
    "longitude": -50.3962
  },
  {
    "codigo": "BRPA043",
    "nome": "Terminal Vila do Conde",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501303,
    "latitude": -1.50588,
    "longitude": -48.7373
  },
  {
    "codigo": "BRPA045",
    "nome": "Hidrovias do Brasil Miritituba",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.27222,
    "longitude": -55.945
  },
  {
    "codigo": "BRPA046",
    "nome": "Esta��o Cianport Miritituba",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.26495,
    "longitude": -55.9403
  },
  {
    "codigo": "BRPA049",
    "nome": "Cruz Tavares Transportadora",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.283,
    "longitude": -56.021
  },
  {
    "codigo": "BRPA055",
    "nome": "Porto Samal",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.295,
    "longitude": -48.434
  },
  {
    "codigo": "BRPA056",
    "nome": "Reicon Vit�ria do Xingu",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1508357,
    "latitude": -2.882,
    "longitude": -52.011
  },
  {
    "codigo": "BRPA057",
    "nome": "Reicon Itaituba",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.279,
    "longitude": -56.011
  },
  {
    "codigo": "BRPA059",
    "nome": "Minera��o Rio do Norte - Rampa de Suprimentos",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1505304,
    "latitude": -1.461,
    "longitude": -56.376
  },
  {
    "codigo": "BRPA060",
    "nome": "Minera��o Rio do Norte - P�tio de Toras",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1505304,
    "latitude": -1.461,
    "longitude": -56.383
  },
  {
    "codigo": "BRPA061",
    "nome": "TUP CESARI",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.287,
    "longitude": -48.433
  },
  {
    "codigo": "BRPA062",
    "nome": "Minera��o Rio do Norte - Balsa Matuera",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1505304,
    "latitude": -1.461,
    "longitude": -56.377
  },
  {
    "codigo": "BRPA064",
    "nome": "Base de Distribui��o Secund�ria de Itaituba",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.28514,
    "longitude": -56.0274
  },
  {
    "codigo": "BRPA065",
    "nome": "Companhia Brasileira de Asfalto da Amaz�nia",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500800,
    "latitude": -1.34613,
    "longitude": -48.3468
  },
  {
    "codigo": "BRPA066",
    "nome": "Belo Monte Log�stica de Terminal",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1508357,
    "latitude": -3.10981,
    "longitude": -51.751
  },
  {
    "codigo": "BRPA067",
    "nome": "Norte Log",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.278,
    "longitude": -48.452
  },
  {
    "codigo": "BRPA068",
    "nome": "Itaipava Itaituba",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.35006,
    "longitude": -56.1975
  },
  {
    "codigo": "BRPA069",
    "nome": "Itaipava Icoaraci Bel�m",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.31142,
    "longitude": -48.4875
  },
  {
    "codigo": "BRPA070",
    "nome": "Terminal Itaipava Santar�m",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.42893,
    "longitude": -54.6958
  },
  {
    "codigo": "BRPA074",
    "nome": "Porto da Rio Preto",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.476,
    "longitude": -48.474
  },
  {
    "codigo": "BRPA076",
    "nome": "Porto Sousa Sobrinho",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.477,
    "longitude": -48.489
  },
  {
    "codigo": "BRPA077",
    "nome": "Deck Panor�mico Gold Mar",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.431,
    "longitude": -48.493
  },
  {
    "codigo": "BRPA078",
    "nome": "Porto da Sociedade B�blica do Brasil",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.476,
    "longitude": -48.466
  },
  {
    "codigo": "BRPA079",
    "nome": "Amarena Apoio Portu�rio Turismo e Reparo Naval",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.413,
    "longitude": -48.495
  },
  {
    "codigo": "BRPA080",
    "nome": "Hermar Log",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.476,
    "longitude": -48.474
  },
  {
    "codigo": "BRPA081",
    "nome": "Marinas do Porto",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.476,
    "longitude": -48.473
  },
  {
    "codigo": "BRPA082",
    "nome": "Porto Amazonas",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.45,
    "longitude": -48.502
  },
  {
    "codigo": "BRPA083",
    "nome": "Delima Bel�m",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.41167,
    "longitude": -48.4942
  },
  {
    "codigo": "BRPA085",
    "nome": "Porto Unirios II",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.424,
    "longitude": -54.7
  },
  {
    "codigo": "BRPA086",
    "nome": "Reicon-Bel�m",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.354,
    "longitude": -48.47
  },
  {
    "codigo": "BRPA087",
    "nome": "Porto Nals Navega��o Apoio Log�stico e Servi�os",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.3,
    "longitude": -48.491
  },
  {
    "codigo": "BRPA088",
    "nome": "Sindicato Rural de Santar�m",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.434,
    "longitude": -54.69
  },
  {
    "codigo": "BRPA089",
    "nome": "Bar Beira Rio",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501808,
    "latitude": -1.689,
    "longitude": -50.488
  },
  {
    "codigo": "BRPA091",
    "nome": "ATEM Miritituba",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.26,
    "longitude": -55.935
  },
  {
    "codigo": "BRPA092",
    "nome": "Hidrovi�ria Tapaj�s",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.419,
    "longitude": -54.721
  },
  {
    "codigo": "BRPA095",
    "nome": "Trapiche Municipal de Cachoeira do Arari",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1502004,
    "latitude": -1.011,
    "longitude": -48.964
  },
  {
    "codigo": "BRPA105",
    "nome": "Posto Alian�a",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501808,
    "latitude": -1.687,
    "longitude": -50.489
  },
  {
    "codigo": "BRPA108",
    "nome": "Terminal Saint-Gobain Icoaraci",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.32721,
    "longitude": -48.4852
  },
  {
    "codigo": "BRPA116",
    "nome": "Atl�ntica Norte",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.292,
    "longitude": -48.431
  },
  {
    "codigo": "BRPA119",
    "nome": "Point do A�a�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501808,
    "latitude": -1.691,
    "longitude": -50.484
  },
  {
    "codigo": "BRPA123",
    "nome": "E V da Silva Servi�os- ME",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503903,
    "latitude": -2.15,
    "longitude": -56.093
  },
  {
    "codigo": "BRPA125",
    "nome": "Maar Navega��o e Terminais Ltda",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.372,
    "longitude": -48.483
  },
  {
    "codigo": "BRPA126",
    "nome": "Rampa de Acesso da Abramex Madeiras",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1504703,
    "latitude": -2.151,
    "longitude": -56.094
  },
  {
    "codigo": "BRPA127",
    "nome": "Terminal Hidrovi�rio de Camar�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506302,
    "latitude": -0.943,
    "longitude": -48.606
  },
  {
    "codigo": "BRPA128",
    "nome": "Flutuante Apoio Lady Min",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503903,
    "latitude": -1.891,
    "longitude": -48.786
  },
  {
    "codigo": "BRPA134",
    "nome": "Terminal Boa Esperan�a Camet�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1502103,
    "latitude": -2.277,
    "longitude": -49.381
  },
  {
    "codigo": "BRPA135",
    "nome": "Estaleiro e Tornearia do Candinho",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.427,
    "longitude": -54.745
  },
  {
    "codigo": "BRPA136",
    "nome": "Industria de Madeira S�o Tomaz Eireli - EPP",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501501,
    "latitude": -1.266,
    "longitude": -48.339
  },
  {
    "codigo": "BRPA137",
    "nome": "Reicon Santar�m",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.431,
    "longitude": -54.694
  },
  {
    "codigo": "BRPA138",
    "nome": "Porto Brilhante",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.46,
    "longitude": -48.507
  },
  {
    "codigo": "BRPA139",
    "nome": "B. M. Castro Eireli - EPP",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.423,
    "longitude": -54.701
  },
  {
    "codigo": "BRPA140",
    "nome": "Porto S�o Francisco",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501303,
    "latitude": -1.559,
    "longitude": -48.505
  },
  {
    "codigo": "BRPA141",
    "nome": "Rampa de Acesso da Lacarpex",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1504703,
    "latitude": -1.891,
    "longitude": -48.786
  },
  {
    "codigo": "BRPA142",
    "nome": "Trapiche do G�s",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500305,
    "latitude": -0.16,
    "longitude": -50.391
  },
  {
    "codigo": "BRPA143",
    "nome": "Est�ncia STM",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.477,
    "longitude": -48.491
  },
  {
    "codigo": "BRPA144",
    "nome": "Jarum� Rodofluvial",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.456,
    "longitude": -48.506
  },
  {
    "codigo": "BRPA145",
    "nome": "Porto Rom�o",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1507979,
    "latitude": -2.076,
    "longitude": -56.501
  },
  {
    "codigo": "BRPA146",
    "nome": "Benedito Mutran e Cia",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.476,
    "longitude": -48.465
  },
  {
    "codigo": "BRPA147",
    "nome": "Porto Dourado",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.477,
    "longitude": -48.49
  },
  {
    "codigo": "BRPA148",
    "nome": "Porto do Posto S�o Benedito",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1505809,
    "latitude": -1.935,
    "longitude": -50.825
  },
  {
    "codigo": "BRPA149",
    "nome": "Estaleiro Rio Maguari S/A",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.286,
    "longitude": -48.433
  },
  {
    "codigo": "BRPA150",
    "nome": "Ant�nio F de Carvalho EPP",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500503,
    "latitude": -1.532,
    "longitude": -52.575
  },
  {
    "codigo": "BRPA151",
    "nome": "Ind�stria de Esquadrias Barsa",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500800,
    "latitude": -1.331,
    "longitude": -48.345
  },
  {
    "codigo": "BRPA152",
    "nome": "Posto Pompeia",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500503,
    "latitude": -1.532,
    "longitude": -52.576
  },
  {
    "codigo": "BRPA153",
    "nome": "Porto de Itaituba da Caramuru Alimentos",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.352,
    "longitude": -56.185
  },
  {
    "codigo": "BRPA155",
    "nome": "Porto Rodofluvial Barcarena",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501303,
    "latitude": -1.518,
    "longitude": -48.643
  },
  {
    "codigo": "BRPA160",
    "nome": "Porto Seguro",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.476,
    "longitude": -48.462
  },
  {
    "codigo": "BRPA161",
    "nome": "Porto de Apoio W X L Queen",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.274,
    "longitude": -48.34
  },
  {
    "codigo": "BRPA162",
    "nome": "Brasil Verde Esquadrias Eireli EPP",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501501,
    "latitude": -1.273,
    "longitude": -48.339
  },
  {
    "codigo": "BRPA163",
    "nome": "Porto Prates",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.295,
    "longitude": -48.435
  },
  {
    "codigo": "BRPA164",
    "nome": "Terminal Leomar",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503903,
    "latitude": -2.151,
    "longitude": -56.094
  },
  {
    "codigo": "BRPA165",
    "nome": "Porto Caravelas",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.414,
    "longitude": -48.494
  },
  {
    "codigo": "BRPA166",
    "nome": "Marques Pinto Navega��o Ltda",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.42,
    "longitude": -54.705
  },
  {
    "codigo": "BRPA167",
    "nome": "Gilson Rafael Manzoli Cassini",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501501,
    "latitude": -1.277,
    "longitude": -48.34
  },
  {
    "codigo": "BRPA168",
    "nome": "Porto do Trapiche Municipal",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1502509,
    "latitude": -0.162,
    "longitude": -49.982
  },
  {
    "codigo": "BRPA170",
    "nome": "Porto Macap�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.477,
    "longitude": -48.493
  },
  {
    "codigo": "BRPA171",
    "nome": "Porto AFC",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501501,
    "latitude": -1.263,
    "longitude": -48.328
  },
  {
    "codigo": "BRPA172",
    "nome": "Porto Barros ou Parag�s",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501808,
    "latitude": -1.691,
    "longitude": -50.485
  },
  {
    "codigo": "BRPA173",
    "nome": "Porto Santa Efigenia",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.462,
    "longitude": -48.507
  },
  {
    "codigo": "BRPA174",
    "nome": "Ipiranga Com�rcio e Servi�os Eireli - EPP",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1505809,
    "latitude": -2.046,
    "longitude": -50.797
  },
  {
    "codigo": "BRPA175",
    "nome": "Itaipava S/A",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.284,
    "longitude": -48.483
  },
  {
    "codigo": "BRPA176",
    "nome": "Terminal Boa Esperan�a Carapaj�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1502103,
    "latitude": -2.278,
    "longitude": -49.381
  },
  {
    "codigo": "BRPA179",
    "nome": "Porto de Apoio Amazon Woods",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501501,
    "latitude": -1.254,
    "longitude": -48.318
  },
  {
    "codigo": "BRPA180",
    "nome": "Super Posto S�o Benedito",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.475,
    "longitude": -48.472
  },
  {
    "codigo": "BRPA181",
    "nome": "R de Jesus Com�rcio de Madeitas Ltda",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501501,
    "latitude": -1.275,
    "longitude": -48.341
  },
  {
    "codigo": "BRPA183",
    "nome": "Henvil - Terminal Hidrovi�rio de Bel�m (Icoaraci)",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.3,
    "longitude": -48.49
  },
  {
    "codigo": "BRPA184",
    "nome": "Porto Rodofluvial Barcarena I",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.45,
    "longitude": -48.502
  },
  {
    "codigo": "BRPA185",
    "nome": "Porto Le�o do Maraj�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Constru��o Conclu�da",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.688,
    "longitude": -50.489
  },
  {
    "codigo": "BRPA186",
    "nome": "Trapiche de Soure",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1507904,
    "latitude": -0.73,
    "longitude": -48.522
  },
  {
    "codigo": "BRPA187",
    "nome": "Reicon - Senador Jos� Porf�rio",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1507805,
    "latitude": -2.587,
    "longitude": -51.956
  },
  {
    "codigo": "BRPA188",
    "nome": "UTE Novo Tempo Barcarena",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501303,
    "latitude": -1.529,
    "longitude": -48.746
  },
  {
    "codigo": "BRPA189",
    "nome": "Jarum� - Porto Arapari",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501303,
    "latitude": -1.559,
    "longitude": -48.506
  },
  {
    "codigo": "BRPA190",
    "nome": "Terminal Hidrovi�rio de Cargas e Passageiros de Terra Santa",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1507979,
    "latitude": -2.111,
    "longitude": -56.492
  },
  {
    "codigo": "BRPA191",
    "nome": "Terminal Hidrovi�rio de Passageiros e Cargas de Faro",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503002,
    "latitude": -2.175,
    "longitude": -56.746
  },
  {
    "codigo": "BRPA192",
    "nome": "Terminal Hidrovi�rio de Prainha/PA",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506005,
    "latitude": -1.809,
    "longitude": -53.481
  },
  {
    "codigo": "BRPA193",
    "nome": "Terminal Hidrovi�rios de Cargas e Passageiros de Santar�m",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.427,
    "longitude": -54.698
  },
  {
    "codigo": "BRPA194",
    "nome": "Porto R S Lima",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1507607,
    "latitude": -1.619,
    "longitude": -47.495
  },
  {
    "codigo": "BRPA195",
    "nome": "Porto Olinda",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.477,
    "longitude": -48.462
  },
  {
    "codigo": "BRPA196",
    "nome": "ERAM ESTALEIRO RIO AMAZONAS",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501303,
    "latitude": -1.498,
    "longitude": -48.62
  },
  {
    "codigo": "BRPA197",
    "nome": "EASA-ESTALEIROS AMAZ�NIA S.A.",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.365,
    "longitude": -48.479
  },
  {
    "codigo": "BRPA198",
    "nome": "Porto Linave",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.341,
    "longitude": -48.48
  },
  {
    "codigo": "BRPA199",
    "nome": "Porto de Apoio Madeiras Santa Maria",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1504703,
    "latitude": -1.887,
    "longitude": -48.777
  },
  {
    "codigo": "BRPA200",
    "nome": "Porto NL",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.342,
    "longitude": -48.481
  },
  {
    "codigo": "BRPA201",
    "nome": "Porto Silnave Bel�m",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.317,
    "longitude": -48.486
  },
  {
    "codigo": "BRPA202",
    "nome": "Porto Macaca�ba",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503903,
    "latitude": -2.139,
    "longitude": -56.089
  },
  {
    "codigo": "BRPA203",
    "nome": "Porto Santa Maria",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1507607,
    "latitude": -1.617,
    "longitude": -47.495
  },
  {
    "codigo": "BRPA204",
    "nome": "Norte Marine",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.361,
    "longitude": -48.482
  },
  {
    "codigo": "BRPA205",
    "nome": "Porto Gelo Friomar",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501808,
    "latitude": -1.688,
    "longitude": -50.489
  },
  {
    "codigo": "BRPA206",
    "nome": "Rampa Samal",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.424,
    "longitude": -54.699
  },
  {
    "codigo": "BRPA207",
    "nome": "Terminal Hidrovi�rio de Cargas e Passageiros de Almeirim",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500503,
    "latitude": -1.532,
    "longitude": -52.576
  },
  {
    "codigo": "BRPA208",
    "nome": "Terminal de Munguba",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500503,
    "latitude": -0.917336,
    "longitude": -52.4252
  },
  {
    "codigo": "BRPA209",
    "nome": "Base de Oriximin� - BARIX",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1505304,
    "latitude": -1.46147,
    "longitude": -56.3841
  },
  {
    "codigo": "BRPA210",
    "nome": "Rampa de Acesso Cigana",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501956,
    "latitude": -2.24,
    "longitude": -46.433
  },
  {
    "codigo": "BRPA211",
    "nome": "Nova Era Industria Com�rcio Exporta��o de Madeira Ltda - ME",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1504703,
    "latitude": -1.887,
    "longitude": -48.776
  },
  {
    "codigo": "BRPA212",
    "nome": "Terminal Hidrovi�rio de Passageiros e Cargas de Alenquer",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500404,
    "latitude": -1.958,
    "longitude": -54.738
  },
  {
    "codigo": "BRPA213",
    "nome": "PROMAP - PRODUTOS DE MADEIRA DO PARA LTDA",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.289,
    "longitude": -48.459
  },
  {
    "codigo": "BRPA214",
    "nome": "ABI Miritituba",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.302,
    "longitude": -55.971
  },
  {
    "codigo": "BRPA215",
    "nome": "Porto Jiquiriqui",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1504802,
    "latitude": -2.016,
    "longitude": -54.094
  },
  {
    "codigo": "BRPA216",
    "nome": "Trapiche de Icoaraci",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.29871,
    "longitude": -48.4908
  },
  {
    "codigo": "BRPA217",
    "nome": "Terminal Hidrovi�rio da Pra�a Princesa Isabel",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.476,
    "longitude": -48.476
  },
  {
    "codigo": "BRPA218",
    "nome": "Associa��o das Comunidades Remanescentes de Quilombos Gurup�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503101,
    "latitude": -1.497,
    "longitude": -51.793
  },
  {
    "codigo": "BRPA219",
    "nome": "Tapaj�s Administra��o Portu�ria Ltda",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.428,
    "longitude": -54.757
  },
  {
    "codigo": "BRPA220",
    "nome": "Hidrovia Tapajos II",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503903,
    "latitude": -2.151,
    "longitude": -56.094
  },
  {
    "codigo": "BRPA221",
    "nome": "Hidrovia Tapajos III",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500404,
    "latitude": -1.958,
    "longitude": -54.739
  },
  {
    "codigo": "BRPA222",
    "nome": "Rio Doce Madeiras Ltda",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501501,
    "latitude": -1.27,
    "longitude": -48.338
  },
  {
    "codigo": "BRPA223",
    "nome": "Rampa de acesso da empresa Madeireira J &amp; Y Ltda.",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1504703,
    "latitude": -1.9,
    "longitude": -48.794
  },
  {
    "codigo": "BRPA224",
    "nome": "Rampa de Apoio Atividade de Pequeno Porte",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1504703,
    "latitude": -1.904,
    "longitude": -48.8
  },
  {
    "codigo": "BRPA225",
    "nome": "Bertolini Paragominas",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1505502,
    "latitude": -2.94,
    "longitude": -47.799
  },
  {
    "codigo": "BRPA226",
    "nome": "Hidrovi�rio Erlonav",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.418,
    "longitude": -54.722
  },
  {
    "codigo": "BRPA229",
    "nome": "Rampa para embarque e desembarque de produtos florestais da empresa Comercial Manoel Passos Eireli",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500000,
    "latitude": -1.88665,
    "longitude": -48.7765
  },
  {
    "codigo": "BRPA230",
    "nome": "Terminal UNI-Z",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.2701,
    "longitude": -55.9453
  },
  {
    "codigo": "BRPA231",
    "nome": "Registro Bertolini Santar�m  - Maica",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.42986,
    "longitude": -54.6945
  },
  {
    "codigo": "BRPA232",
    "nome": "Porto AR Transporte",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.43344,
    "longitude": -48.4928
  },
  {
    "codigo": "BRPA233",
    "nome": "Terminal Rodofluvial de Bel�m - Travessia por Balsa",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.47574,
    "longitude": -48.4702
  },
  {
    "codigo": "BRPA234",
    "nome": "Bertolini Itaituba",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.284,
    "longitude": -56.0225
  },
  {
    "codigo": "BRPA235",
    "nome": "COMINA EMPRESA DE MINERA��O EIRELI",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506195,
    "latitude": -4.81268,
    "longitude": -55.803
  },
  {
    "codigo": "BRPA236",
    "nome": "Porto do Gelo",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1504703,
    "latitude": -1.88665,
    "longitude": -48.7769
  },
  {
    "codigo": "BRPA237",
    "nome": "Administra��o de Bens de Infraestrutura - ABI",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.42883,
    "longitude": -54.6946
  },
  {
    "codigo": "BRPA238",
    "nome": "Rampa de Apoio para a empresa Eco Brasil Florestal  EIRELI",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506351,
    "latitude": -1.22282,
    "longitude": -48.3044
  },
  {
    "codigo": "BRPA239",
    "nome": "Madeireira Madeval Ltda ME",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1504703,
    "latitude": -1.98625,
    "longitude": -48.7961
  },
  {
    "codigo": "BRPA240",
    "nome": "Madeireira S�o Jos� Eireli",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1504703,
    "latitude": -1.88917,
    "longitude": -48.7797
  },
  {
    "codigo": "BRPA241",
    "nome": "Gr�o Par� Naval",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.29173,
    "longitude": -48.4294
  },
  {
    "codigo": "BRPA243",
    "nome": "Assis materiais de Constru��o",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500000,
    "latitude": -1.461,
    "longitude": -48.489
  },
  {
    "codigo": "BRPA244",
    "nome": "Benevides Madeiras",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501501,
    "latitude": -1.26417,
    "longitude": -48.327
  },
  {
    "codigo": "BRPA245",
    "nome": "Porto",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.28743,
    "longitude": -48.4422
  },
  {
    "codigo": "BRPA246",
    "nome": "Petr�leo Sabb� - Itaituba",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.27911,
    "longitude": -56.0092
  },
  {
    "codigo": "BRPA247",
    "nome": "Terminal LDC Tapaj�s",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506195,
    "latitude": -4.21,
    "longitude": -55.85
  },
  {
    "codigo": "BRPA248",
    "nome": "Cargill Agr�cola S.A. (ETC Miritituba/PA)",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.26,
    "longitude": -55.94
  },
  {
    "codigo": "BRPA249",
    "nome": "Petr�leo Sabb� - Miritituba",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.319,
    "longitude": -56.013
  },
  {
    "codigo": "BRPA250",
    "nome": "Arapari - Bel�m",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500000,
    "latitude": -1.45698,
    "longitude": -48.5063
  },
  {
    "codigo": "BRPA251",
    "nome": "Homem de Nazar�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.42869,
    "longitude": -54.6947
  },
  {
    "codigo": "BRPA252",
    "nome": "Porto do Alci",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1504802,
    "latitude": -2.01191,
    "longitude": -54.0821
  },
  {
    "codigo": "BRPA253",
    "nome": "Rampa de apoio M G Agroflorestal",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1504703,
    "latitude": -1.89923,
    "longitude": -48.7967
  },
  {
    "codigo": "BRPA254",
    "nome": "Porto Fortimber",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500000,
    "latitude": -1.27908,
    "longitude": -48.456
  },
  {
    "codigo": "BRPA256",
    "nome": "Porto Prainha",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.4236,
    "longitude": -54.6992
  },
  {
    "codigo": "BRPA257",
    "nome": "Registro Bertolini Miritituba",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.29003,
    "longitude": -55.9611
  },
  {
    "codigo": "BRPA258",
    "nome": "RAMPA DE APOIO PAR� TIMBER",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1504703,
    "latitude": -1.90253,
    "longitude": -48.8002
  },
  {
    "codigo": "BRPA259",
    "nome": "RAMPA DE APOIO INDUMEX",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503408,
    "latitude": -1.46819,
    "longitude": -48.0291
  },
  {
    "codigo": "BRPA260",
    "nome": "Terminal Hidrovi�rio de Cargas e Passageiros de Santana do Tapar�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.27642,
    "longitude": -54.5287
  },
  {
    "codigo": "BRPA261",
    "nome": "Terminal Hidrovi�rio de Cargas e Passageiros de Curu�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1502855,
    "latitude": -1.89594,
    "longitude": -55.1179
  },
  {
    "codigo": "BRPA262",
    "nome": "TOP - Tapajos Operador Portu�rio",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.2586,
    "longitude": -55.9322
  },
  {
    "codigo": "BRPA264",
    "nome": "PORTO ACARI MIRITITUBA",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.29797,
    "longitude": -55.9673
  },
  {
    "codigo": "BRPA265",
    "nome": "M C Navega��o",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.30794,
    "longitude": -48.4896
  },
  {
    "codigo": "BRPA266",
    "nome": "Porto do DEER",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.4237,
    "longitude": -54.6975
  },
  {
    "codigo": "BRPA268",
    "nome": "R MACIEL FERREIRA (Rio Branco)",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500305,
    "latitude": -0.158359,
    "longitude": -50.3933
  },
  {
    "codigo": "BRPA272",
    "nome": "Porto Tapaj�s RZ",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500000,
    "latitude": -4.37197,
    "longitude": -56.0691
  },
  {
    "codigo": "BRPA273",
    "nome": "Estaleiro Maar Navega��o e Terminais Ltda",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.37188,
    "longitude": -48.4835
  },
  {
    "codigo": "BRPA274",
    "nome": "Porto Mamuru",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503903,
    "latitude": -3.16747,
    "longitude": -56.5863
  },
  {
    "codigo": "BRPA275",
    "nome": "Amazonia florestal",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.30063,
    "longitude": -55.9702
  },
  {
    "codigo": "BRPA276",
    "nome": "Porto Acari Miritituba",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.28377,
    "longitude": -56.0219
  },
  {
    "codigo": "BRPA278",
    "nome": "Posto Deus � Fiel II",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1502103,
    "latitude": -2.24992,
    "longitude": -49.4979
  },
  {
    "codigo": "BRPA282",
    "nome": "ARROZAL ESTALEIRO",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500000,
    "latitude": -1.4808,
    "longitude": -48.6916
  },
  {
    "codigo": "BRPA283",
    "nome": "Rampa de Apoio Mapara",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503408,
    "latitude": -1.46889,
    "longitude": -48.0242
  },
  {
    "codigo": "BRPA287",
    "nome": "IP4 de Abaetetuba",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500107,
    "latitude": -1.7238,
    "longitude": -48.8915
  },
  {
    "codigo": "BRPA288",
    "nome": "COOPERATIVA DE AREEIROS DO RIO XINGU - COOPARXING",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500602,
    "latitude": -3.20009,
    "longitude": -52.2
  },
  {
    "codigo": "BRPA289",
    "nome": "Instala��o de apoio portuario",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500000,
    "latitude": -1.30747,
    "longitude": -48.4346
  },
  {
    "codigo": "BRPA290",
    "nome": "IP4 de Viseu",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1508308,
    "latitude": -1.20858,
    "longitude": -46.1368
  },
  {
    "codigo": "BRPA291",
    "nome": "IP4 de Augusto Corr�a",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500909,
    "latitude": -0.980678,
    "longitude": -46.589
  },
  {
    "codigo": "BRPA292",
    "nome": "CBL Reparos Navais Eireli - Estaleiro Metaltech",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501303,
    "latitude": -1.4721,
    "longitude": -48.6877
  },
  {
    "codigo": "BRPA293",
    "nome": "IP4 de S�o Miguel do Guam�",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1507607,
    "latitude": -1.62432,
    "longitude": -47.4858
  },
  {
    "codigo": "BRPA294",
    "nome": "TUP LDC Rio Par�",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1505700,
    "latitude": -1.5037,
    "longitude": -48.9004
  },
  {
    "codigo": "BRPA295",
    "nome": "IP4 de Camet�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1502103,
    "latitude": -2.23732,
    "longitude": -49.4934
  },
  {
    "codigo": "BRPA296",
    "nome": "TLA Terminais de L�quidos da Amaz�nia",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500107,
    "latitude": -1.6339,
    "longitude": -48.8325
  },
  {
    "codigo": "BRPA297",
    "nome": "ATEM Santar�m",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.43956,
    "longitude": -54.6813
  },
  {
    "codigo": "BRPA300",
    "nome": "Terminal Fluvial Vit�ria",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1505304,
    "latitude": -1.4608,
    "longitude": -56.3778
  },
  {
    "codigo": "BRPA301",
    "nome": "Terminal Fluvial Vit�ria",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1505304,
    "latitude": -1.4608,
    "longitude": -56.3778
  },
  {
    "codigo": "BRPA308",
    "nome": "MINERADORA TAPAJOS � INDUSTRIA E COMERCIO LTDA",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501006,
    "latitude": -3.83757,
    "longitude": -55.4989
  },
  {
    "codigo": "BRPA309",
    "nome": "Serraria Rio Capim",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500958,
    "latitude": -2.02012,
    "longitude": -47.7486
  },
  {
    "codigo": "BRPA310",
    "nome": "IP4 de Bel�m (Mosqueiro)",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.16591,
    "longitude": -48.4752
  },
  {
    "codigo": "BRPA311",
    "nome": "A�ai Petr�leo Par�",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Constru��o Conclu�da",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506195,
    "latitude": -4.20024,
    "longitude": -55.8323
  },
  {
    "codigo": "BRPA312",
    "nome": "Porto Tavares",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500107,
    "latitude": -1.72926,
    "longitude": -48.8941
  },
  {
    "codigo": "BRPA313",
    "nome": "HBR EMPREENDIMENTOS",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1507904,
    "latitude": -0.736485,
    "longitude": -48.5172
  },
  {
    "codigo": "BRPA314",
    "nome": "Porto Mizu Maguari",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500800,
    "latitude": -1.32009,
    "longitude": -48.355
  },
  {
    "codigo": "BRPA318",
    "nome": "CURUA-UNA NAVEGA��O E COM�RCIO LTD",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500000,
    "latitude": -2.44066,
    "longitude": -54.6808
  },
  {
    "codigo": "BRPA321",
    "nome": "Rampa de Acesso PEDRO RIVA &amp; CIA",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.4426,
    "longitude": -54.6778
  },
  {
    "codigo": "BRPA322",
    "nome": "Rampa de Acesso PEDRO RIVA &amp; CIA",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.4426,
    "longitude": -54.6778
  },
  {
    "codigo": "BRPA323",
    "nome": "Rampa de Acesso PEDRO RIVA &amp; CIA",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1506807,
    "latitude": -2.4426,
    "longitude": -54.6778
  },
  {
    "codigo": "BRPA324",
    "nome": "ATEM Bel�m-PA",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1501402,
    "latitude": -1.33601,
    "longitude": -48.4865
  },
  {
    "codigo": "BRPA327",
    "nome": "P�eres 1 ao 5 - Orla de Santar�m",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500000,
    "latitude": -2.41869,
    "longitude": -54.7203
  },
  {
    "codigo": "BRPA328",
    "nome": "TUP Acar� - Emam Asfaltos",
    "tipo": "Terminal de uso privado",
    "situacao": "Constru��o Iniciada",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500206,
    "latitude": -1.47947,
    "longitude": -48.3
  },
  {
    "codigo": "BRPA332",
    "nome": "Terminal Hidrovi�rio de Passageiros e Cargas do Munic�pio de Afu�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1500000,
    "latitude": -0.157578,
    "longitude": -50.3931
  },
  {
    "codigo": "BRPA333",
    "nome": "INSTALA��O DE APOIO AO TRANSPORTE AQUAVI�RIO ATHO",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1507979,
    "latitude": -2.10139,
    "longitude": -56.4996
  },
  {
    "codigo": "BRPA334",
    "nome": "Rampa de Apoio Atividade Florestal: CICOMAL",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1507607,
    "latitude": -1.37491,
    "longitude": -47.2903
  },
  {
    "codigo": "BRPA335",
    "nome": "Rampa de Apoio�Colatina�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1507607,
    "latitude": -1.61889,
    "longitude": -47.4972
  },
  {
    "codigo": "BRPA336",
    "nome": "ETC Bertuol Fertilizantes",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1503606,
    "latitude": -4.28099,
    "longitude": -55.956
  },
  {
    "codigo": "BRPB001",
    "nome": "Terminal Portu�rio Tabulog",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2511905,
    "latitude": -7.4934,
    "longitude": -34.8212
  },
  {
    "codigo": "BRPBV",
    "nome": "Porto dos Ga�chos",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Porto dos Ga�chos",
    "municipioIbge": 5106800,
    "latitude": -11.535,
    "longitude": -57.414
  },
  {
    "codigo": "BRPCL",
    "nome": "Barra do Riacho",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "ES",
    "municipioNome": "Aracruz",
    "municipioIbge": 3200600,
    "latitude": -19.838499,
    "longitude": -40.058399
  },
  {
    "codigo": "BRPE001",
    "nome": "Estaleiro Atl�ntico Sul - EAS",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2607208,
    "latitude": -8.381,
    "longitude": -34.972
  },
  {
    "codigo": "BRPE002",
    "nome": "Estaleiro VARD PROMAR",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2607208,
    "latitude": -8.371,
    "longitude": -34.972
  },
  {
    "codigo": "BRPE003",
    "nome": "Porto de Santo Ant�nio (IP4 Fernando de Noronha)",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2605459,
    "latitude": -3.834,
    "longitude": -32.401
  },
  {
    "codigo": "BRPEO",
    "nome": "Presidente Epit�cio",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "SP",
    "municipioNome": "Presidente Epit�cio",
    "municipioIbge": 3541300,
    "latitude": -21.754899,
    "longitude": -52.1011
  },
  {
    "codigo": "BRPET",
    "nome": "Pelotas �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "RS",
    "municipioNome": "Pelotas",
    "municipioIbge": 4314400,
    "latitude": -31.781943,
    "longitude": -52.333888
  },
  {
    "codigo": "BRPHB",
    "nome": "Parna�ba",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PI",
    "municipioNome": "Parna�ba",
    "municipioIbge": 2207700,
    "latitude": -2.943299000000001,
    "longitude": -41.7959
  },
  {
    "codigo": "BRPHI",
    "nome": "Pinheiro",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Pinheiro",
    "municipioIbge": 2108600,
    "latitude": -2.514,
    "longitude": -45.07
  },
  {
    "codigo": "BRPI004",
    "nome": "Porto de Lu�s Correia",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2205706,
    "latitude": -2.87386,
    "longitude": -41.6471
  },
  {
    "codigo": "BRPIN",
    "nome": "Parintins",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Parintins",
    "municipioIbge": 1303400,
    "latitude": -2.624,
    "longitude": -56.734
  },
  {
    "codigo": "BRPIV",
    "nome": "Pirapora",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MG",
    "municipioNome": "Buritizeiro",
    "municipioIbge": 3109400,
    "latitude": -17.342,
    "longitude": -44.955
  },
  {
    "codigo": "BRPMH",
    "nome": "Porto Murtinho",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MS",
    "municipioNome": "Porto Murtinho",
    "municipioIbge": 5006900,
    "latitude": -21.698611,
    "longitude": -57.891666
  },
  {
    "codigo": "BRPMW",
    "nome": "Palmas",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "TO",
    "municipioNome": "Palmas",
    "municipioIbge": 1721000,
    "latitude": -10.087077,
    "longitude": -48.36408100000001
  },
  {
    "codigo": "BRPNA",
    "nome": "Panorama",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "SP",
    "municipioNome": "Panorama",
    "municipioIbge": 3535400,
    "latitude": -21.350829,
    "longitude": -51.857562
  },
  {
    "codigo": "BRPNB",
    "nome": "Porto Nacional",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "TO",
    "municipioNome": "Porto Nacional",
    "municipioIbge": 1718200,
    "latitude": -10.708899,
    "longitude": -48.4183
  },
  {
    "codigo": "BRPNE",
    "nome": "Penedo",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AL",
    "municipioNome": "Penedo",
    "municipioIbge": 2706700,
    "latitude": -10.290699,
    "longitude": -36.5861
  },
  {
    "codigo": "BRPNG",
    "nome": "Paranagu�",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "PR",
    "municipioNome": "Paranagu�",
    "municipioIbge": 4118200,
    "latitude": -25.502221,
    "longitude": -48.505555
  },
  {
    "codigo": "BRPNS",
    "nome": "Pederneiras",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "SP",
    "municipioNome": "Pederneiras",
    "municipioIbge": 3536700,
    "latitude": -22.349734,
    "longitude": -48.718589
  },
  {
    "codigo": "BRPNZ",
    "nome": "Petrolina",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PE",
    "municipioNome": "Petrolina",
    "municipioIbge": 2611100,
    "latitude": -9.4016,
    "longitude": -40.5183
  },
  {
    "codigo": "BRPOA",
    "nome": "Porto Alegre �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "RS",
    "municipioNome": "Porto Alegre",
    "municipioIbge": 4314900,
    "latitude": -30.007221,
    "longitude": -51.211111
  },
  {
    "codigo": "BRPR001",
    "nome": "Terminal Portu�rio Porto Pontal - TPPP",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4119954,
    "latitude": -25.55,
    "longitude": -48.3717
  },
  {
    "codigo": "BRPR002",
    "nome": "Cattalini Terminais Mar�timos",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4118204,
    "latitude": -25.5018,
    "longitude": -48.5352
  },
  {
    "codigo": "BRPR003",
    "nome": "Terminal Porto do Rio Igua�u",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4108304,
    "latitude": -25.5908,
    "longitude": -54.5792
  },
  {
    "codigo": "BRPR005",
    "nome": "Unidade Offshore Techint - UOT",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4119954,
    "latitude": -25.5552,
    "longitude": -48.3689
  },
  {
    "codigo": "BRPR006",
    "nome": "Brit�nia",
    "tipo": "Terminal de uso privado",
    "situacao": "INOPERANTE",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4118451,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRPR007",
    "nome": "Parque de Constru��o Submarina do Paran�",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4119954,
    "latitude": -25.5553,
    "longitude": -48.4353
  },
  {
    "codigo": "BRPR008",
    "nome": "Novo Porto Terminais Multicargas e Log�sticas LTDA",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4118204,
    "latitude": -25.517,
    "longitude": -48.577
  },
  {
    "codigo": "BRPR009",
    "nome": "Porto Guar� Infraestrutura SPE S/A",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4118204,
    "latitude": -25.5189,
    "longitude": -48.5633
  },
  {
    "codigo": "BRPRP",
    "nome": "Propri�",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "SE",
    "municipioNome": "Propri�",
    "municipioIbge": 2805700,
    "latitude": -10.2101,
    "longitude": -36.8322
  },
  {
    "codigo": "BRPSO",
    "nome": "Pimenteiras do Oeste",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "RO",
    "municipioNome": "Pimenteiras do Oeste",
    "municipioIbge": 1101460,
    "latitude": -13.483,
    "longitude": -61.046999
  },
  {
    "codigo": "BRPTC",
    "nome": "Porto Franco",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Porto Franco",
    "municipioIbge": 2109000,
    "latitude": -6.336079,
    "longitude": -47.40809899999999
  },
  {
    "codigo": "BRPTQ",
    "nome": "Porto De Moz",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Porto de Moz",
    "municipioIbge": 1505900,
    "latitude": -1.75267,
    "longitude": -52.247834
  },
  {
    "codigo": "BRPTR",
    "nome": "Porto Rico",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PR",
    "municipioNome": "Porto Rico",
    "municipioIbge": 4120200,
    "latitude": -22.771999,
    "longitude": -53.267
  },
  {
    "codigo": "BRPVH",
    "nome": "Porto Velho �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "RO",
    "municipioNome": "Porto Velho",
    "municipioIbge": 1100200,
    "latitude": -8.748889,
    "longitude": -63.91527800000001
  },
  {
    "codigo": "BRQAV",
    "nome": "Benjamin Constant",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "AM",
    "municipioNome": "Benjamin Constant",
    "municipioIbge": 1300600,
    "latitude": -4.373,
    "longitude": -70.028
  },
  {
    "codigo": "BRQDB",
    "nome": "Cachoeira do Sul",
    "tipo": "Porto Organizado",
    "situacao": "Inoperante",
    "uf": "RS",
    "municipioNome": "Cachoeira do Sul",
    "municipioIbge": 4303000,
    "latitude": -30.0518,
    "longitude": -52.87899899999999
  },
  {
    "codigo": "BRQGA",
    "nome": "Gua�ra",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PR",
    "municipioNome": "Gua�ra",
    "municipioIbge": 4108800,
    "latitude": -24.070599,
    "longitude": -54.24210000000001
  },
  {
    "codigo": "BRRBB",
    "nome": "Borba",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Borba",
    "municipioIbge": 1300800,
    "latitude": -4.385,
    "longitude": -59.593
  },
  {
    "codigo": "BRRBR",
    "nome": "Rio Branco",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "AC",
    "municipioNome": "Rio Branco",
    "municipioIbge": 1200400,
    "latitude": -9.979599,
    "longitude": -67.809499
  },
  {
    "codigo": "BRREC",
    "nome": "Recife �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "PE",
    "municipioNome": "Recife",
    "municipioIbge": 2611600,
    "latitude": -8.053888,
    "longitude": -34.868332
  },
  {
    "codigo": "BRRIG",
    "nome": "Rio Grande �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "RS",
    "municipioNome": "Rio Grande",
    "municipioIbge": 4315600,
    "latitude": -32.042499,
    "longitude": -52.075555
  },
  {
    "codigo": "BRRIO",
    "nome": "Rio de Janeiro�",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "RJ",
    "municipioNome": "Rio de Janeiro",
    "municipioIbge": 3304550,
    "latitude": -22.892222,
    "longitude": -43.195278
  },
  {
    "codigo": "BRRJ001",
    "nome": "Terminal da Ilha Gua�ba - TIG",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3302601,
    "latitude": -23.013,
    "longitude": -44.033
  },
  {
    "codigo": "BRRJ002",
    "nome": "Keppel Fels",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRRJ003",
    "nome": "Cosan Lubrificantes e Especialidades",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.823,
    "longitude": -43.163
  },
  {
    "codigo": "BRRJ004",
    "nome": "Porto Engenheiro Zephyrino Lavan�re Machado Filho",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3302403,
    "latitude": -22.386,
    "longitude": -41.768
  },
  {
    "codigo": "BRRJ005",
    "nome": "BRICLOG",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.87,
    "longitude": -43.2072
  },
  {
    "codigo": "BRRJ006",
    "nome": "Porto Novo Rio",
    "tipo": "Terminal de uso privado",
    "situacao": "INOPERANTE",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRRJ007",
    "nome": "Terminal Estaleiro Mau�",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.877,
    "longitude": -43.129
  },
  {
    "codigo": "BRRJ008",
    "nome": "Terminal Aquavi�rio de Ilha Redonda e Terminal Aquavi�rio da Ilha Comprida",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.802,
    "longitude": -43.12
  },
  {
    "codigo": "BRRJ009",
    "nome": "Terminal Aquavi�rio de Angra dos Reis",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3300100,
    "latitude": -23.061,
    "longitude": -44.229
  },
  {
    "codigo": "BRRJ010",
    "nome": "Terminal Aquavi�rio da Ilha D'�gua",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.8104,
    "longitude": -43.1625
  },
  {
    "codigo": "BRRJ011",
    "nome": "Brasco Log�stica Offshore",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.872,
    "longitude": -43.125
  },
  {
    "codigo": "BRRJ012",
    "nome": "Estaleiro Brasfels",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3300100,
    "latitude": -23,
    "longitude": -44.247
  },
  {
    "codigo": "BRRJ013",
    "nome": "UTC Engenharia",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.877,
    "longitude": -43.129
  },
  {
    "codigo": "BRRJ014",
    "nome": "MAC LAREN OIL ESTALEIROS",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.881,
    "longitude": -43.12
  },
  {
    "codigo": "BRRJ015",
    "nome": "Terminal Mar�timo Ponte do Thun",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.832,
    "longitude": -43.172
  },
  {
    "codigo": "BRRJ016",
    "nome": "Terminal TKCSA",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.931,
    "longitude": -43.777
  },
  {
    "codigo": "BRRJ017",
    "nome": "Terminal Portu�rio Wellstream - TPW",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.866,
    "longitude": -43.118
  },
  {
    "codigo": "BRRJ018",
    "nome": "Terminal Flex�vel de GNL da Ba�a da Guanabara",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.783,
    "longitude": -43.132
  },
  {
    "codigo": "BRRJ019",
    "nome": "Terminal Mar�timo Braskem",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3301702,
    "latitude": -22.7639,
    "longitude": -43.1538
  },
  {
    "codigo": "BRRJ020",
    "nome": "Porto do A�u - Terminal de Min�rio",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3305000,
    "latitude": -21.8179,
    "longitude": -41.0118
  },
  {
    "codigo": "BRRJ021",
    "nome": "Terminal Aquavi�rio da Ilha Comprida",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.802,
    "longitude": -43.12
  },
  {
    "codigo": "BRRJ022",
    "nome": "Porto do A�u - Terminal TMULT e TCAR",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3305000,
    "latitude": -21.8532,
    "longitude": -41.0205
  },
  {
    "codigo": "BRRJ023",
    "nome": "Porto Sudeste do Brasil S/A",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3302007,
    "latitude": -22.925,
    "longitude": -43.852
  },
  {
    "codigo": "BRRJ024",
    "nome": "Terminal Portu�rio Estaleiro Brasa",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.876,
    "longitude": -43.124
  },
  {
    "codigo": "BRRJ025",
    "nome": "TERMINAL TECHNIP BRASIL A�U",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3305000,
    "latitude": -21.8719,
    "longitude": -41.0119
  },
  {
    "codigo": "BRRJ026",
    "nome": "TUP Intermoor - Base de Apoio Mar�timo Intermoor A��",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3305000,
    "latitude": -21.8674,
    "longitude": -41.0151
  },
  {
    "codigo": "BRRJ027",
    "nome": "Estaleiro Locar",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.8264,
    "longitude": -43.1682
  },
  {
    "codigo": "BRRJ031",
    "nome": "Estaleiro Barcas S/A",
    "tipo": "Registro - Estaleiro at� 1.000 TPB",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.879,
    "longitude": -43.121
  },
  {
    "codigo": "BRRJ039",
    "nome": "Terminal Nov Flexibles",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3305000,
    "latitude": -21.869,
    "longitude": -41.014
  },
  {
    "codigo": "BRRJ041",
    "nome": "Estaleiro Camorim",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.871,
    "longitude": -43.112
  },
  {
    "codigo": "BRRJ044",
    "nome": "Enaval - Engenharia Naval e Offshore",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.8792,
    "longitude": -43.1221
  },
  {
    "codigo": "BRRJ045",
    "nome": "Estaleiro ETP",
    "tipo": "Registro - Estaleiro at� 1.000 TPB",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.863,
    "longitude": -43.128
  },
  {
    "codigo": "BRRJ046",
    "nome": "Estaleiro TCE",
    "tipo": "Registro - Estaleiro at� 1.000 TPB",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.872,
    "longitude": -43.113
  },
  {
    "codigo": "BRRJ047",
    "nome": "TCE Servi�os",
    "tipo": "Registro - Estaleiro at� 1.000 TPB",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.874,
    "longitude": -43.113
  },
  {
    "codigo": "BRRJ048",
    "nome": "Uote Transpetro",
    "tipo": "Registro - Instala��o para transfer�ncia",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3301009,
    "latitude": -22.162,
    "longitude": -40.343
  },
  {
    "codigo": "BRRJ050",
    "nome": "Porto Veleiro B�zios",
    "tipo": "Instala��o portu�ria de turismo",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3300233,
    "latitude": -22.748,
    "longitude": -41.8825
  },
  {
    "codigo": "BRRJ051",
    "nome": "Terminal de Combust�veis Mar�timos do A�u - TECMA",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3305000,
    "latitude": -21.8492,
    "longitude": -41.0081
  },
  {
    "codigo": "BRRJ052",
    "nome": "P�er do Centro na Praia do Canto",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3300233,
    "latitude": -22.754,
    "longitude": -41.887
  },
  {
    "codigo": "BRRJ053",
    "nome": "Brasil Log�stica Offshore e Estaleiro Naval",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3305000,
    "latitude": -21.865,
    "longitude": -41.016
  },
  {
    "codigo": "BRRJ054",
    "nome": "Terminal Portu�rio da Nuclep",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3302007,
    "latitude": -22.904,
    "longitude": -43.847
  },
  {
    "codigo": "BRRJ055",
    "nome": "Estaleiro Renave",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.8638,
    "longitude": -43.1279
  },
  {
    "codigo": "BRRJ056",
    "nome": "Terminal CCPN",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.8652,
    "longitude": -43.1307
  },
  {
    "codigo": "BRRJ057",
    "nome": "Terminal Ilha do Governador",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.823,
    "longitude": -43.1636
  },
  {
    "codigo": "BRRJ060",
    "nome": "Terminal Dock Brasil (extinto)",
    "tipo": "Registro - Estaleiro",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304904,
    "latitude": -22.8336,
    "longitude": -43.0969
  },
  {
    "codigo": "BRRJ061",
    "nome": "DOME - Terminais Portu�rios",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3305000,
    "latitude": -21.855,
    "longitude": -41.007
  },
  {
    "codigo": "BRRJ063",
    "nome": "Tranship Gradim",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304904,
    "latitude": -22.826,
    "longitude": -43.095
  },
  {
    "codigo": "BRRJ064",
    "nome": "Cais do Mercado de Peixes de Maca�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3302403,
    "latitude": -22.375,
    "longitude": -41.775
  },
  {
    "codigo": "BRRJ065",
    "nome": "Terminais Ponta Negra",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3302700,
    "latitude": -22.946,
    "longitude": -42.681
  },
  {
    "codigo": "BRRJ066",
    "nome": "Subsea 7 do Brasil Servi�os LTDA",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.874,
    "longitude": -43.121
  },
  {
    "codigo": "BRRJ067",
    "nome": "Terminal de Petr�leo TPET/TOIL - A�u",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3305000,
    "latitude": -21.812,
    "longitude": -40.981
  },
  {
    "codigo": "BRRJ069",
    "nome": "Coroa Grande Servi�os Portu�rios",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3302007,
    "latitude": -22.904,
    "longitude": -43.85
  },
  {
    "codigo": "BRRJ070",
    "nome": "P�er Terminal Janeth Dias",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3300100,
    "latitude": -23.139,
    "longitude": -44.168
  },
  {
    "codigo": "BRRJ071",
    "nome": "P�er Esta��o Santa Luzia",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3300100,
    "latitude": -23.008,
    "longitude": -44.316
  },
  {
    "codigo": "BRRJ072",
    "nome": "P�er de Turismo da Vila do Abra�o",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3300100,
    "latitude": -23.139,
    "longitude": -44.166
  },
  {
    "codigo": "BRRJ073",
    "nome": "P�er de Transatl�ntico da Passagem de Cabo Frio",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3300704,
    "latitude": -22.874,
    "longitude": -42.009
  },
  {
    "codigo": "BRRJ074",
    "nome": "Terminal de Regaseifica��o do A�u",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3305000,
    "latitude": -21.835,
    "longitude": -40.99
  },
  {
    "codigo": "BRRJ075",
    "nome": "Sidiney Gomes",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3302403,
    "latitude": -22.368,
    "longitude": -41.778
  },
  {
    "codigo": "BRRJ078",
    "nome": "Terminal Dome",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3305000,
    "latitude": -21.8552,
    "longitude": -41.0087
  },
  {
    "codigo": "BRRJ080",
    "nome": "Mac Laren Opera��es Offshore",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.8689,
    "longitude": -43.1208
  },
  {
    "codigo": "BRRJ081",
    "nome": "Brasbunker S�o Gon�alo",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304904,
    "latitude": -22.8259,
    "longitude": -43.094
  },
  {
    "codigo": "BRRJ082",
    "nome": "CODEPE",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.877,
    "longitude": -43.121
  },
  {
    "codigo": "BRRJ083",
    "nome": "Terminal Dock Brasil",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304904,
    "latitude": -22.8307,
    "longitude": -43.0974
  },
  {
    "codigo": "BRRJ084",
    "nome": "Superpesa",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.8696,
    "longitude": -43.2153
  },
  {
    "codigo": "BRRJ085",
    "nome": "TEPOR - Terminal Portu�rio de Maca�",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3302403,
    "latitude": -22.3255,
    "longitude": -41.7241
  },
  {
    "codigo": "BRRJ086",
    "nome": "UTE RIO DE JANEIRO",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3302007,
    "latitude": -22.9498,
    "longitude": -43.8065
  },
  {
    "codigo": "BRRJ088",
    "nome": "Terminal Distrito Industrial de Santa Cruz",
    "tipo": "Terminal de uso privado",
    "situacao": "Constru��o Iniciada",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.9151,
    "longitude": -43.7611
  },
  {
    "codigo": "BRRJ089",
    "nome": "TERMINAL DE USO PRIVADO OCEANEERING",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3303302,
    "latitude": -22.8677,
    "longitude": -43.1177
  },
  {
    "codigo": "BRRJ090",
    "nome": "TUP ALISEO",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3305000,
    "latitude": -21.8573,
    "longitude": -41.0125
  },
  {
    "codigo": "BRRJ091",
    "nome": "FMC TECNOLOGIES",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.8678,
    "longitude": -43.2138
  },
  {
    "codigo": "BRRJ092",
    "nome": "Pier 2 - PqT UFRJ",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3304557,
    "latitude": -22.8678,
    "longitude": -43.2138
  },
  {
    "codigo": "BRRN001",
    "nome": "Terminal Aquavi�rio de Guamar�",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2404507,
    "latitude": -5.13833,
    "longitude": -36.3825
  },
  {
    "codigo": "BRRN002",
    "nome": "Dunas",
    "tipo": "Terminal de uso privado",
    "situacao": "INOPERANTE",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2408102,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRRN003",
    "nome": "Terminal de Embarque Mar�timo da Salina Diamante Branco",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2404101,
    "latitude": -5.115,
    "longitude": -36.24
  },
  {
    "codigo": "BRRN004",
    "nome": "Terminal de Uso Privado de Macau",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2407203,
    "latitude": -5.106,
    "longitude": -36.666
  },
  {
    "codigo": "BRRN005",
    "nome": "Tup da Salina Francisco Menescal",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2408003,
    "latitude": -5.00945,
    "longitude": -37.1432
  },
  {
    "codigo": "BRRN006",
    "nome": "TUP da Salina Guanabara",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2408003,
    "latitude": -5.01288,
    "longitude": -37.1954
  },
  {
    "codigo": "BRRN007",
    "nome": "Salinor Salinas do Nordeste S.A. (Unidade Unidos)",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2407203,
    "latitude": -5.10457,
    "longitude": -36.6666
  },
  {
    "codigo": "BRRN008",
    "nome": "TURCAZIMUTAL SERVI�O DE ELETROMECANICA",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2408102,
    "latitude": -5.78106,
    "longitude": -35.2089
  },
  {
    "codigo": "BRRN009",
    "nome": "Porto de Guamar�",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2404507,
    "latitude": -5.1061,
    "longitude": -36.317
  },
  {
    "codigo": "BRRN010",
    "nome": "Porto Guamar� (Excluir - em duplicidade com BRRN009)",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2404507,
    "latitude": -5.1066,
    "longitude": -36.3179
  },
  {
    "codigo": "BRRN011",
    "nome": "Estaleiro One Ship",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2400000,
    "latitude": -4.95058,
    "longitude": -37.1356
  },
  {
    "codigo": "BRRO001",
    "nome": "Itaituba Ind�stria de Cimentos",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.70361,
    "longitude": -63.9192
  },
  {
    "codigo": "BRRO002",
    "nome": "Belmont",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.72028,
    "longitude": -63.92
  },
  {
    "codigo": "BRRO003",
    "nome": "Terminal Fog�s",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.73444,
    "longitude": -63.9194
  },
  {
    "codigo": "BRRO004",
    "nome": "Aquavia",
    "tipo": "Terminal de uso privado",
    "situacao": "INOPERANTE",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100106,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRRO005",
    "nome": "Passar�o",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.71583,
    "longitude": -63.92
  },
  {
    "codigo": "BRRO006",
    "nome": "Cargill Agr�cola",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.741,
    "longitude": -63.919
  },
  {
    "codigo": "BRRO007",
    "nome": "AIVEL",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.70963,
    "longitude": -63.9198
  },
  {
    "codigo": "BRRO008",
    "nome": "Estaleiro Amaz�nia Navega��es",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.711,
    "longitude": -63.919
  },
  {
    "codigo": "BRRO009",
    "nome": "TEVEL",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.73035,
    "longitude": -63.919
  },
  {
    "codigo": "BRRO010",
    "nome": "ATEM PVH",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.70212,
    "longitude": -63.9172
  },
  {
    "codigo": "BRRO011",
    "nome": "Terminal Amazong�s",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.75101,
    "longitude": -63.9158
  },
  {
    "codigo": "BRRO013",
    "nome": "Terminal de Expedi��o de Gr�os Portochuelo",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.62139,
    "longitude": -63.8083
  },
  {
    "codigo": "BRRO014",
    "nome": "Esta��o Cujubinzinho",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.58,
    "longitude": -63.722
  },
  {
    "codigo": "BRRO019",
    "nome": "L P Moreira de Luna",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.781,
    "longitude": -63.915
  },
  {
    "codigo": "BRRO020",
    "nome": "Instala��o Rudimentar L.A de Oliveira",
    "tipo": "Registro - Instala��o rudimentar",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.717,
    "longitude": -63.926
  },
  {
    "codigo": "BRRO022",
    "nome": "F. H. de Oliveira Peixoto",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.707,
    "longitude": -63.9197
  },
  {
    "codigo": "BRRO024",
    "nome": "Aquavia",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100106,
    "latitude": -10.793,
    "longitude": -65.347
  },
  {
    "codigo": "BRRO025",
    "nome": "Base Secund�ria Ipiranga de Porto Velho",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.73028,
    "longitude": -63.9186
  },
  {
    "codigo": "BRRO027",
    "nome": "Estaleiro Guaraj� M�quinas",
    "tipo": "Registro - Estaleiro",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100106,
    "latitude": -10.795,
    "longitude": -65.346
  },
  {
    "codigo": "BRRO028",
    "nome": "IP4 de Cai N' �gua (Porto Velho)",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.77,
    "longitude": -63.909
  },
  {
    "codigo": "BRRO029",
    "nome": "Instala��o de Apoio ao Transporte Aquavi�rio SC Carvalho",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.727,
    "longitude": -63.919
  },
  {
    "codigo": "BRRO030",
    "nome": "Distribuidora Equador de Produtos de Petr�leo S.A",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.62168,
    "longitude": -63.8098
  },
  {
    "codigo": "BRRO031",
    "nome": "Navega��o Cunha Ltda.",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.623,
    "longitude": -63.917
  },
  {
    "codigo": "BRRO032",
    "nome": "Navega��o Mady",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.699,
    "longitude": -63.918
  },
  {
    "codigo": "BRRO033",
    "nome": "Rampa de Acesso para Carga e Descarga",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.6,
    "longitude": -63.754
  },
  {
    "codigo": "BRRO036",
    "nome": "IP4 de Guajar�-Mirim",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100106,
    "latitude": -10.7943,
    "longitude": -65.3458
  },
  {
    "codigo": "BRRO037",
    "nome": "M P Flores Com�rcio e Transporte e Exporta��o",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100106,
    "latitude": -10.7906,
    "longitude": -65.3492
  },
  {
    "codigo": "BRRO038",
    "nome": "Porto Madeira",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.73286,
    "longitude": -63.9262
  },
  {
    "codigo": "BRRO039",
    "nome": "PORTO BEIRA RIO",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100080,
    "latitude": -12.4526,
    "longitude": -64.2323
  },
  {
    "codigo": "BRRO040",
    "nome": "Terminal PVH - II",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Constru��o Iniciada",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.61668,
    "longitude": -63.7941
  },
  {
    "codigo": "BRRO042",
    "nome": "TERMINAL DE GRANEIS S�LIDOS AGR�COLAS � TGSA PORTO CHUELO",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1100205,
    "latitude": -8.6105,
    "longitude": -63.7887
  },
  {
    "codigo": "BRROO",
    "nome": "Rondon�polis",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "Rondon�polis",
    "municipioIbge": 5107600,
    "latitude": -16.469609,
    "longitude": -54.969805
  },
  {
    "codigo": "BRROS",
    "nome": "Rosana",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "SP",
    "municipioNome": "Rosana",
    "municipioIbge": 3544250,
    "latitude": -22.595624,
    "longitude": -53.02555
  },
  {
    "codigo": "BRRR001",
    "nome": "Base de Caracara� - BARAC",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1400209,
    "latitude": 1.81058,
    "longitude": -61.1281
  },
  {
    "codigo": "BRRR002",
    "nome": "IP4 de Caracara�",
    "tipo": "Registro - Instala��o portu�ria p�blica",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1400209,
    "latitude": 1.82,
    "longitude": -61.125
  },
  {
    "codigo": "BRRR003",
    "nome": "Porto Trairi - Caracara�",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1400209,
    "latitude": 1.79974,
    "longitude": -61.1348
  },
  {
    "codigo": "BRRR004",
    "nome": "Porto Calnorte",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1400209,
    "latitude": -1.79585,
    "longitude": -61.1356
  },
  {
    "codigo": "BRRS001",
    "nome": "Yara Brasil Fertilizantes",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4315602,
    "latitude": -32.0795,
    "longitude": -52.095
  },
  {
    "codigo": "BRRS002",
    "nome": "Terbian - Terminal Bianchini",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4315602,
    "latitude": -32.1028,
    "longitude": -52.1046
  },
  {
    "codigo": "BRRS003",
    "nome": "Terminal Santa Clara",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4322004,
    "latitude": -29.9014,
    "longitude": -51.3744
  },
  {
    "codigo": "BRRS004",
    "nome": "Moinho Taquariense",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4321303,
    "latitude": -29.8075,
    "longitude": -51.8725
  },
  {
    "codigo": "BRRS005",
    "nome": "Terminal Mar�timo Luiz Fogliatto - Termasa",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4315602,
    "latitude": -32.115,
    "longitude": -52.1031
  },
  {
    "codigo": "BRRS006",
    "nome": "Bianchini Canoas",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4304606,
    "latitude": -29.9161,
    "longitude": -51.2397
  },
  {
    "codigo": "BRRS007",
    "nome": "Terminal Portu�rio Bunge Alimentos",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4315602,
    "latitude": -32.0999,
    "longitude": -52.1041
  },
  {
    "codigo": "BRRS008",
    "nome": "Terminal Privado Copelmi",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4305355,
    "latitude": -29.949,
    "longitude": -51.624
  },
  {
    "codigo": "BRRS009",
    "nome": "Terminal Aquavi�rio de Os�rio",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4313508,
    "latitude": -29.9828,
    "longitude": -50.1903
  },
  {
    "codigo": "BRRS010",
    "nome": "Terminal Aquavi�rio de Niter�i",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4304606,
    "latitude": -29.968,
    "longitude": -51.179
  },
  {
    "codigo": "BRRS011",
    "nome": "Terminal Mita",
    "tipo": "Terminal de uso privado",
    "situacao": "INOPERANTE",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4321303,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRRS012",
    "nome": "Terminal Hidrovi�rio Cimbag�",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4314407,
    "latitude": -31.785,
    "longitude": -52.343
  },
  {
    "codigo": "BRRS013",
    "nome": "CMPC Gua�ba",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4309308,
    "latitude": -30.1354,
    "longitude": -51.3089
  },
  {
    "codigo": "BRRS014",
    "nome": "TUP Supergasbr�s",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4304606,
    "latitude": -29.9675,
    "longitude": -51.2025
  },
  {
    "codigo": "BRRS015",
    "nome": "Oleoplan",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4304606,
    "latitude": -29.968,
    "longitude": -51.182
  },
  {
    "codigo": "BRRS016",
    "nome": "Terminal de G�s do Sul - Tergasul",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4304606,
    "latitude": -29.967,
    "longitude": -51.204
  },
  {
    "codigo": "BRRS022",
    "nome": "Unidade Misturadora de Porto Alegre",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4314902,
    "latitude": -29.9682,
    "longitude": -51.1787
  },
  {
    "codigo": "BRRS024",
    "nome": "Nidera Sementes",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4304606,
    "latitude": -29.93,
    "longitude": -51.237
  },
  {
    "codigo": "BRRS025",
    "nome": "Metasa SA Ind�stria Metalurgica",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4305355,
    "latitude": -29.9412,
    "longitude": -51.5715
  },
  {
    "codigo": "BRRS028",
    "nome": "Unidade Misturadora de Canoas",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4304606,
    "latitude": -29.97,
    "longitude": -51.199
  },
  {
    "codigo": "BRRS029",
    "nome": "Estaleiro Oxnaval",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4314407,
    "latitude": -31.785,
    "longitude": -52.347
  },
  {
    "codigo": "BRRS030",
    "nome": "Merlim",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4314902,
    "latitude": -29.969,
    "longitude": -51.192
  },
  {
    "codigo": "BRRS032",
    "nome": "Terminal Portu�rio Estrela",
    "tipo": "Terminal de uso privado",
    "situacao": "Constru��o Conclu�da",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4307807,
    "latitude": -29.4782,
    "longitude": -51.9722
  },
  {
    "codigo": "BRRS033",
    "nome": "Cais Estrela",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4307807,
    "latitude": -29.4746,
    "longitude": -51.9646
  },
  {
    "codigo": "BRRS034",
    "nome": "Terminal Cimbag� (Intercement)",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4314407,
    "latitude": -31.785,
    "longitude": -52.343
  },
  {
    "codigo": "BRRS035",
    "nome": "ETC WIETH WIETH",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4311007,
    "latitude": -32.5909,
    "longitude": -53.3131
  },
  {
    "codigo": "BRRS036",
    "nome": "TUP NSR - Nova Santa Rita",
    "tipo": "Terminal de uso privado",
    "situacao": "Constru��o Conclu�da",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4313375,
    "latitude": -29.9314,
    "longitude": -51.283
  },
  {
    "codigo": "BRRS038",
    "nome": "TUP PORTO MERIDIONAL PARTICIPA��ES",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4301057,
    "latitude": -29.5059,
    "longitude": -49.853
  },
  {
    "codigo": "BRSAL",
    "nome": "Salinas",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RN",
    "municipioNome": "Areia Branca",
    "municipioIbge": 2401100,
    "latitude": -4.946666,
    "longitude": -37.1375
  },
  {
    "codigo": "BRSAS",
    "nome": "Bacia Sedimentar de Santos",
    "tipo": "Plataforma Mar�tima",
    "situacao": "Operando",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": null,
    "latitude": -26.186002,
    "longitude": -44.282378
  },
  {
    "codigo": "BRSC001",
    "nome": "Terminal Portu�rio Braskarne",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4208203,
    "latitude": -26.8964,
    "longitude": -48.6711
  },
  {
    "codigo": "BRSC005",
    "nome": "Estaleiro Itaja� S/A",
    "tipo": "Registro - Estaleiro",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4208203,
    "latitude": -26.891,
    "longitude": -48.67
  },
  {
    "codigo": "BRSC007",
    "nome": "Terminal Aquavi�rio de S�o Francisco do Sul",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4216206,
    "latitude": -26.2279,
    "longitude": -48.5299
  },
  {
    "codigo": "BRSC008",
    "nome": "Portonave - Terminais Portu�rios de Navegantes",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4211306,
    "latitude": -26.8981,
    "longitude": -48.6616
  },
  {
    "codigo": "BRSC010",
    "nome": "Trocadeiro",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4208203,
    "latitude": -26.888,
    "longitude": -48.684
  },
  {
    "codigo": "BRSC011",
    "nome": "Porto Itapo� Terminais Portu�rios",
    "tipo": "Terminal de uso privado",
    "situacao": "Constru��o Iniciada",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4208450,
    "latitude": -26.183,
    "longitude": -48.606
  },
  {
    "codigo": "BRSC012",
    "nome": "Teporti",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4208203,
    "latitude": -26.8766,
    "longitude": -48.7114
  },
  {
    "codigo": "BRSC013",
    "nome": "Barra do Rio Terminal Portu�rio",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4208203,
    "latitude": -26.8833,
    "longitude": -48.6721
  },
  {
    "codigo": "BRSC014",
    "nome": "Terminal Privativo de Imbituba",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4207304,
    "latitude": -28.2264,
    "longitude": -48.657
  },
  {
    "codigo": "BRSC015",
    "nome": "Dow Itaja�",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4208203,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRSC017",
    "nome": "Poly Terminais Portu�rios",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4208203,
    "latitude": -26.87,
    "longitude": -48.706
  },
  {
    "codigo": "BRSC018",
    "nome": "Estaleiro Navship",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4211306,
    "latitude": -26.879,
    "longitude": -48.69
  },
  {
    "codigo": "BRSC019",
    "nome": "Porto Belo",
    "tipo": "Instala��o portu�ria de turismo",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4213500,
    "latitude": -27.154,
    "longitude": -48.544
  },
  {
    "codigo": "BRSC023",
    "nome": "Terminal TGSC",
    "tipo": "Terminal de uso privado",
    "situacao": "Constru��o Iniciada",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4216206,
    "latitude": -26.2333,
    "longitude": -48.6333
  },
  {
    "codigo": "BRSC024",
    "nome": "P�er de Passageiros do Centro Hist�rico",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4216206,
    "latitude": -26.241,
    "longitude": -48.641
  },
  {
    "codigo": "BRSC026",
    "nome": "Atracadouro Barra Sul",
    "tipo": "Instala��o portu�ria de turismo",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4202008,
    "latitude": -27.004,
    "longitude": -48.603
  },
  {
    "codigo": "BRSC027",
    "nome": "TGB - Terminal Graneleiro da Babitonga",
    "tipo": "Terminal de uso privado",
    "situacao": "Constru��o Iniciada",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4216206,
    "latitude": -26.2751,
    "longitude": -48.6709
  },
  {
    "codigo": "BRSC029",
    "nome": "Lunasub N�utica Ltda",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4213500,
    "latitude": -27.157,
    "longitude": -48.553
  },
  {
    "codigo": "BRSC030",
    "nome": "Estaleiro de Constru��o e Manuten��o de Embarca��es",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4211306,
    "latitude": -26.901,
    "longitude": -48.661
  },
  {
    "codigo": "BRSC031",
    "nome": "Terminal G�s Sul - TGS",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4216206,
    "latitude": -26.172,
    "longitude": -48.567
  },
  {
    "codigo": "BRSC033",
    "nome": "Atracadouro de Ferry-boat",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4208203,
    "latitude": -26.885,
    "longitude": -48.682
  },
  {
    "codigo": "BRSC034",
    "nome": "Instala��o de Turismo PDBS",
    "tipo": "Instala��o portu�ria de turismo",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4202008,
    "latitude": -26.999,
    "longitude": -48.605
  },
  {
    "codigo": "BRSC035",
    "nome": "Barra Sul Turismo N�utico",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4202008,
    "latitude": -27.005,
    "longitude": -48.603
  },
  {
    "codigo": "BRSC036",
    "nome": "Keppel Singmarine do Brasil",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4211306,
    "latitude": -26.862,
    "longitude": -48.702
  },
  {
    "codigo": "BRSC037",
    "nome": "Estaleiro Maccarini LTDA",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4211306,
    "latitude": -26.888,
    "longitude": -48.662
  },
  {
    "codigo": "BRSC038",
    "nome": "Atracadouro de Ferry-Boat I",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4208203,
    "latitude": -26.903,
    "longitude": -48.657
  },
  {
    "codigo": "BRSC039",
    "nome": "Atracadouro de Ferry-Boat II",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4211306,
    "latitude": -26.9033,
    "longitude": -48.6564
  },
  {
    "codigo": "BRSC040",
    "nome": "Oce�nica Empresa de Apoio � navega��o Ltda",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4216206,
    "latitude": -26.241,
    "longitude": -48.64
  },
  {
    "codigo": "BRSC041",
    "nome": "Estaleiro - Detroit Brasil",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4208203,
    "latitude": -26.857,
    "longitude": -48.723
  },
  {
    "codigo": "BRSC042",
    "nome": "Mar Azul",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4216206,
    "latitude": -26.2727,
    "longitude": -48.6511
  },
  {
    "codigo": "BRSC044",
    "nome": "Keppel Singmarine Brasil",
    "tipo": "Terminal de uso privado",
    "situacao": "Constru��o Conclu�da",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4211306,
    "latitude": -26.863,
    "longitude": -48.7018
  },
  {
    "codigo": "BRSC045",
    "nome": "Terminal de Gran�is L�quidos Itaja�",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4208203,
    "latitude": -26.8918,
    "longitude": -48.671
  },
  {
    "codigo": "BRSC046",
    "nome": "Petrobras Transporte - Transpetro - Atracadouro",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4216206,
    "latitude": -26.218,
    "longitude": -48.5004
  },
  {
    "codigo": "BRSC047",
    "nome": "Porto Park",
    "tipo": "Instala��o portu�ria de turismo",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 4212809,
    "latitude": -26.77,
    "longitude": -48.661
  },
  {
    "codigo": "BRSE001",
    "nome": "Terminal Mar�timo In�cio Barbosa - TMIB",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2800605,
    "latitude": -10.844,
    "longitude": -36.919
  },
  {
    "codigo": "BRSE002",
    "nome": "Terminal Aquavi�rio de Aracaju",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2800308,
    "latitude": -11.0041,
    "longitude": -37.0661
  },
  {
    "codigo": "BRSE003",
    "nome": "Terminal GNL da UTE Porto de Sergipe I",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 2800605,
    "latitude": -10.843,
    "longitude": -36.917
  },
  {
    "codigo": "BRSFG",
    "nome": "S�o F�lix do Xingu",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "S�o F�lix do Xingu",
    "municipioIbge": 1507300,
    "latitude": -6.64,
    "longitude": -51.994
  },
  {
    "codigo": "BRSFK",
    "nome": "Soure",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Soure",
    "municipioIbge": 1507900,
    "latitude": -0.725616,
    "longitude": -48.516221
  },
  {
    "codigo": "BRSFS",
    "nome": "S�o Francisco do Sul �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "SC",
    "municipioNome": "S�o Francisco do Sul",
    "municipioIbge": 4216200,
    "latitude": -26.238889,
    "longitude": -48.634721
  },
  {
    "codigo": "BRSIN",
    "nome": "Santa In�s",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Santa In�s",
    "municipioIbge": 2109900,
    "latitude": -3.640897,
    "longitude": -45.374641
  },
  {
    "codigo": "BRSIV",
    "nome": "Silves",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Silves",
    "municipioIbge": 1304000,
    "latitude": -2.962,
    "longitude": -58.142
  },
  {
    "codigo": "BRSJL",
    "nome": "S�o Gabriel da Cachoeira",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "S�o Gabriel da Cachoeira",
    "municipioIbge": 1303800,
    "latitude": -0.129,
    "longitude": -67.092
  },
  {
    "codigo": "BRSJO",
    "nome": "S�o Jer�nimo",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "S�o Jer�nimo",
    "municipioIbge": 4318400,
    "latitude": -29.954399,
    "longitude": -51.72540000000001
  },
  {
    "codigo": "BRSLV",
    "nome": "Salvaterra",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Salvaterra",
    "municipioIbge": 1506300,
    "latitude": -0.754565,
    "longitude": -48.512596
  },
  {
    "codigo": "BRSMV",
    "nome": "Santa Maria da Vit�ria",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "BA",
    "municipioNome": "Santa Maria da Vit�ria",
    "municipioIbge": 2928100,
    "latitude": -13.397999,
    "longitude": -44.198
  },
  {
    "codigo": "BRSNT",
    "nome": "Santa B�rbara do Par�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Santa B�rbara do Par�",
    "municipioIbge": 1506350,
    "latitude": -1.239,
    "longitude": -48.33
  },
  {
    "codigo": "BRSOS",
    "nome": "S�o Sim�o",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "GO",
    "municipioNome": "S�o Sim�o",
    "municipioIbge": 5220400,
    "latitude": -19.064299,
    "longitude": -50.517
  },
  {
    "codigo": "BRSP001",
    "nome": "Terminal Integrador Portu�rio Luiz Antonio Mesquita - TIPLAM",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3548500,
    "latitude": -23.8725,
    "longitude": -46.3717
  },
  {
    "codigo": "BRSP002",
    "nome": "Terminal Mar�timo Privativo de Cubat�o - TMPC",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3513504,
    "latitude": -23.8708,
    "longitude": -46.3764
  },
  {
    "codigo": "BRSP003",
    "nome": "Nobara",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3518701,
    "latitude": null,
    "longitude": null
  },
  {
    "codigo": "BRSP004",
    "nome": "Sucoc�trico Cutrale",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3518701,
    "latitude": -23.9797,
    "longitude": -46.2864
  },
  {
    "codigo": "BRSP005",
    "nome": "Terminal Mar�timo Dow",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3518701,
    "latitude": -23.9821,
    "longitude": -46.866
  },
  {
    "codigo": "BRSP006",
    "nome": "Terminal Aquavi�rio de S�o Sebasti�o (Almirante Barroso)",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3550704,
    "latitude": -23.8039,
    "longitude": -45.3861
  },
  {
    "codigo": "BRSP007",
    "nome": "Terminal Portu�rio de Presidente Epit�cio",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3541307,
    "latitude": -21.755,
    "longitude": -52.105
  },
  {
    "codigo": "BRSP008",
    "nome": "DP World Santos",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3548500,
    "latitude": -23.924,
    "longitude": -46.318
  },
  {
    "codigo": "BRSP009",
    "nome": "Base Log�stica de Dutos",
    "tipo": "Terminal de uso privado",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3518701,
    "latitude": -23.995,
    "longitude": -46.297
  },
  {
    "codigo": "BRSP011",
    "nome": "LDC Pederneiras",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3536703,
    "latitude": -22.36,
    "longitude": -48.711
  },
  {
    "codigo": "BRSP012",
    "nome": "Terminal Portu�rio Brites",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3548500,
    "latitude": -23.8997,
    "longitude": -46.3358
  },
  {
    "codigo": "BRSP014",
    "nome": "Estaleiro Rio Tiet�",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3502804,
    "latitude": -21.044,
    "longitude": -50.49
  },
  {
    "codigo": "BRSP015",
    "nome": "Terminal Intermodal de Conchas",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3512308,
    "latitude": -22.8696,
    "longitude": -48.0041
  },
  {
    "codigo": "BRSP016",
    "nome": "Terminal Mar�timo da Alemoa",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3548500,
    "latitude": -23.9197,
    "longitude": -46.3888
  },
  {
    "codigo": "BRSP017",
    "nome": "Estaleiro Guaruj� I",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3518701,
    "latitude": -23.992,
    "longitude": -46.291
  },
  {
    "codigo": "BRSP018",
    "nome": "Estaleiro Guaruj� II",
    "tipo": "Registro - Estaleiro",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3518701,
    "latitude": -23.992,
    "longitude": -46.291
  },
  {
    "codigo": "BRSP022",
    "nome": "Cais Tur�stico da Vila",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3520400,
    "latitude": -23.777,
    "longitude": -45.36
  },
  {
    "codigo": "BRSP023",
    "nome": "Esta��o ADM Armaz�ns Gerais",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3547007,
    "latitude": -22.6215,
    "longitude": -48.1741
  },
  {
    "codigo": "BRSP026",
    "nome": "Terminal Mar�timo Comodoro Magalh�es",
    "tipo": "Registro - Instala��o de apoio",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3555406,
    "latitude": -23.455,
    "longitude": -45.058
  },
  {
    "codigo": "BRSP027",
    "nome": "TERMINAL DE REGASEIFICA��O DE GNL DE S�O PAULO S.A � TRSP",
    "tipo": "Registro - Instala��o flutuante",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3548500,
    "latitude": -23.9141,
    "longitude": -46.3621
  },
  {
    "codigo": "BRSP028",
    "nome": "TPL - Terminal Portu�rio Log�stico",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3548500,
    "latitude": -23.9014,
    "longitude": -46.3297
  },
  {
    "codigo": "BRSP029",
    "nome": "TUP EBT - Santorini",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3548500,
    "latitude": -23.9187,
    "longitude": -46.3251
  },
  {
    "codigo": "BRSP031",
    "nome": "Santos Terminais Sustentaveis - STS",
    "tipo": "Terminal de uso privado",
    "situacao": "",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 3548500,
    "latitude": -23.9117,
    "longitude": -46.3505
  },
  {
    "codigo": "BRSPV",
    "nome": "S�o Paulo de Oliven�a",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "S�o Paulo de Oliven�a",
    "municipioIbge": 1303900,
    "latitude": -3.464,
    "longitude": -68.951
  },
  {
    "codigo": "BRSQY",
    "nome": "S�o Louren�o do Sul",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "S�o Louren�o do Sul",
    "municipioIbge": 4318800,
    "latitude": -31.369546,
    "longitude": -51.975013
  },
  {
    "codigo": "BRSSA",
    "nome": "Salvador�",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "BA",
    "municipioNome": "Salvador",
    "municipioIbge": 2927400,
    "latitude": -12.965277,
    "longitude": -38.509444
  },
  {
    "codigo": "BRSSO",
    "nome": "S�o Sebasti�o�",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "SP",
    "municipioNome": "S�o Sebasti�o",
    "municipioIbge": 3550700,
    "latitude": -23.811111,
    "longitude": -45.39749999999999
  },
  {
    "codigo": "BRSSZ",
    "nome": "Santos �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "SP",
    "municipioNome": "Guaruj�",
    "municipioIbge": 3518700,
    "latitude": -23.966053,
    "longitude": -46.301939
  },
  {
    "codigo": "BRST1",
    "nome": "Santar�m (orla)",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Santar�m",
    "municipioIbge": 1506800,
    "latitude": -2.448,
    "longitude": -54.671
  },
  {
    "codigo": "BRSTM",
    "nome": "Santar�m �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Santar�m",
    "municipioIbge": 1506800,
    "latitude": -2.415,
    "longitude": -54.737499
  },
  {
    "codigo": "BRSTZ",
    "nome": "Santa Terezinha",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "MT",
    "municipioNome": "Santa Terezinha",
    "municipioIbge": 5107770,
    "latitude": -10.47,
    "longitude": -50.503
  },
  {
    "codigo": "BRSUA",
    "nome": "Suape �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "PE",
    "municipioNome": "Ipojuca",
    "municipioIbge": 2607200,
    "latitude": -8.391944,
    "longitude": -34.968611
  },
  {
    "codigo": "BRSVP",
    "nome": "Santa Vit�ria do Palmar",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "Santa Vit�ria do Palmar",
    "municipioIbge": 4317300,
    "latitude": -33.4986,
    "longitude": -53.4333
  },
  {
    "codigo": "BRSXO",
    "nome": "S�o F�lix do Araguaia",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MT",
    "municipioNome": "S�o F�lix do Araguaia",
    "municipioIbge": 5107850,
    "latitude": -11.615,
    "longitude": -50.66083199999999
  },
  {
    "codigo": "BRTAP",
    "nome": "Tapes",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "Tapes",
    "municipioIbge": 4321100,
    "latitude": -30.672999,
    "longitude": -51.39600000000001
  },
  {
    "codigo": "BRTB1",
    "nome": "Tabatinga (Novo)",
    "tipo": "IP4",
    "situacao": "Em obras",
    "uf": "AM",
    "municipioNome": "Tabatinga",
    "municipioIbge": 1304060,
    "latitude": -4.227,
    "longitude": -69.945
  },
  {
    "codigo": "BRTBT",
    "nome": "Tabatinga",
    "tipo": "IP4",
    "situacao": "Operando",
    "uf": "AM",
    "municipioNome": "Tabatinga",
    "municipioIbge": 1304060,
    "latitude": -4.231,
    "longitude": -69.944
  },
  {
    "codigo": "BRTFF",
    "nome": "Tef�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "AM",
    "municipioNome": "Tef�",
    "municipioIbge": 1304200,
    "latitude": -3.347,
    "longitude": -64.71
  },
  {
    "codigo": "BRTHE",
    "nome": "Teresina",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "PI",
    "municipioNome": "Teresina",
    "municipioIbge": 2211000,
    "latitude": -5.068558,
    "longitude": -42.8352
  },
  {
    "codigo": "BRTIM",
    "nome": "Timon",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Timon",
    "municipioIbge": 2112200,
    "latitude": -5.094235,
    "longitude": -42.822956
  },
  {
    "codigo": "BRTO001",
    "nome": "Porto Praia Norte",
    "tipo": "Esta��o de transbordo de cargas",
    "situacao": "Em Opera��o",
    "uf": "",
    "municipioNome": "",
    "municipioIbge": 1718303,
    "latitude": -5.39144,
    "longitude": -47.8173
  },
  {
    "codigo": "BRTRQ",
    "nome": "Tarauac�",
    "tipo": "Porto P�blico",
    "situacao": "Operando",
    "uf": "AC",
    "municipioNome": "Tarauac�",
    "municipioIbge": 1200600,
    "latitude": -8.168699,
    "longitude": -70.761199
  },
  {
    "codigo": "BRTUR",
    "nome": "Tucuru�",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "PA",
    "municipioNome": "Tucuru�",
    "municipioIbge": 1508100,
    "latitude": -3.789,
    "longitude": -49.657
  },
  {
    "codigo": "BRTUT",
    "nome": "Tut�ia",
    "tipo": "IP4",
    "situacao": "Planejado",
    "uf": "MA",
    "municipioNome": "Tut�ia",
    "municipioIbge": 2112500,
    "latitude": -2.765,
    "longitude": -42.273
  },
  {
    "codigo": "BRURG",
    "nome": "Uruguaiana",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "RS",
    "municipioNome": "Uruguaiana",
    "municipioIbge": 4322400,
    "latitude": -29.746276,
    "longitude": -57.095582
  },
  {
    "codigo": "BRVAJ",
    "nome": "Vit�ria do Jari",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AP",
    "municipioNome": "Vit�ria do Jari",
    "municipioIbge": 1600800,
    "latitude": -0.927606,
    "longitude": -52.423606
  },
  {
    "codigo": "BRVDC",
    "nome": "Vila do Conde�",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "PA",
    "municipioNome": "Barcarena",
    "municipioIbge": 1501300,
    "latitude": -1.544167,
    "longitude": -48.747777
  },
  {
    "codigo": "BRVIX",
    "nome": "Vit�ria �",
    "tipo": "Porto Organizado",
    "situacao": "Operando",
    "uf": "ES",
    "municipioNome": "Vit�ria",
    "municipioIbge": 3205300,
    "latitude": -20.3225,
    "longitude": -40.339444
  },
  {
    "codigo": "BRXQI",
    "nome": "Xique-xique",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "BA",
    "municipioNome": "Xique-Xique",
    "municipioIbge": 2933600,
    "latitude": -10.826639,
    "longitude": -42.731387
  },
  {
    "codigo": "BRZMD",
    "nome": "Sena Madureira",
    "tipo": "Porto P�blico",
    "situacao": "Planejado",
    "uf": "AC",
    "municipioNome": "Sena Madureira",
    "municipioIbge": 1200500,
    "latitude": -9.080426,
    "longitude": -68.663774
  }
]
